/* lua.js generated code 0.3.0 */

var MenuItem = require("clover/panel/component/levelpanel/MenuItem")
var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var ButtonPushBounceIdleBubbleAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")
require("clover/data/Persistence")
var StrategyFlauntPanel = require("clover/panel/StrategyFlauntPanel")
let ShareUtil = require("clover/utils/ShareUtil")
const MedalRankList = require("./component/levelpanel/MedalRankList.js")
LevelRankType = table([1, "kFriend", 1], [1, "kGlobal", 2])

let PassLevelNeedRes = [
    "packed/PassLevelNeedRes.pack",
    "packed/PassLevelNeedFntRes.pack",
    "packed/NewRankBanner.pack",
    "cocos/rank_medal.csb",
    "cocos/start_medal.plist",
]

var WinPanel = xClass("WinPanel", BasePanel)
var WinPanelEvent = table(
    [1, "NextLevel", "WINPANELEVENT.NEXTLEVEL"],
    [1, "Close", "WINPANELEVENT.CLOSE"],
    [1, "StartAnim", "WINPANELEVENT.STARTANIM"],
    [1, "FinishAnim", "WINPANELEVENT.FINISHANIM"],
    [1, "Retry", "WINPANELEVENT.Retry"],
    [1, "ShareMessage", "WINPANELEVENT.SHAREMESSAGE"],
    [1, "SkipChallenge", "WINPANELEVENT.SKIPCHALLENGE"],
    [1, "SkipChallengeCheckRankOver", "WINPANELEVENT.SKIPCHALLENGECHECKRANKOVER"],
    [1, "AddTime", "WINPANELEVENT.ADDTIME"]
)
const uiPos = {
    "score" : 210,
    "activity" : 60,
    "level" : -130,
    "button" : -280,
    "sand" : -210
}
WinPanel.prototype.ctor = function (levelId, star, totalStar, score, rewardList, animTotalStar, oldStar, showShareDouble, challengeRank, isHardLevel, strategyId, rewardConfig, activityRewards, medalData){
    var self = this
    self.init(levelId, star, totalStar, score, rewardList, animTotalStar, oldStar, showShareDouble, challengeRank, isHardLevel, strategyId, rewardConfig, activityRewards,medalData)
}
WinPanel.prototype.init = function (levelId, star, totalStar, score, rewardList, animTotalStar, oldStar, showShareDouble, challengeRank, isHardLevel, strategyId, rewardConfig = {}, activityRewards,medalData){
    var self = this
    self.levelId = levelId
    self.star = star
    self.totalStar = totalStar
    self.score = score
    self.rewardList = rewardList
    self.animTotalStar = animTotalStar || 0
    self.oldStar = oldStar
    self.strategyId = strategyId || ""
    self.isBusy = false
    self.bannerAdName = BannerAdPanel.kWinPanel
    self.gridAdName = GridAdPanel.kWinPanel;
    self.bannerAdOffsetY = MetaManager.getInstance().canShowBannerAd(self.bannerAdName) ? 140 : 0;
    self.bannerAdPanelOffsetY = MetaManager.getInstance().canShowBannerAd(self.bannerAdName) ? 100 : 0;
    self.bannerData = {levelId:levelId}
    self.activityRewards = activityRewards
    self.challengeRank = challengeRank || 0

    self.rewardConfig = {
        times: rewardConfig.times || 0,                                         //  今日剩余领奖次数
        levelUpNeedTimes : rewardConfig.levelUpNeedTimes || 0,                  //  距离下次升挡还需的领奖次数
        type: rewardConfig.type || 0,                                           //  当前领取双倍奖励是否需要看广告
        getTimes: rewardConfig.getTimes || 0,                                   //  今日已领奖次数
        totalGetTimes: rewardConfig.totalGetTimes || 0,                         //  累计已领奖次数
        isGetThisReward: false,                                                 //  本次双倍奖励是否已领取
        isGetShareReward: rewardConfig.isGetShareReward || false,               //  本日分享奖励是否已领取
        isGetShareRewardMax: rewardConfig.isGetShareRewardMax || false,         //  拉新数是否达到上限
        isGetEnergyMax: rewardConfig.isGetEnergyMax  || false                   //  奖励精力值是否达到指定值
    };

    self.showShareDouble = showShareDouble
    ;[self.totalRewards, self.rewardIndex] = self.mergeRewards(self.rewardList)
    self.rewards = table()
    self.isAnimFinished = false
    BasePanel.prototype.init.call(self)
    var bg = self.getChildByName("bg")
    var scorePanel = cc.CSLoader.createNode("cocos/panel_success_score_team.csb")
    scorePanel.setPosition(0, uiPos.score)
    scorePanel.setOpacity(0)

    self.addChild(scorePanel)
    self.scorePanel = scorePanel
    self.addScoreBubble = scorePanel.getChildByName("bubble_team02")
    self.addScoreBubble.setVisible(false)
    self.addScoreBubble.getChildByName("lab").y = 15
    self.addScoreBubble.getChildByName("num").y = 15
    let monthTicketConfig = MetaManager.getInstance().monthTicketConfig || {}
    let score_add =  monthTicketConfig.privilege_card_score_add || 0
    self.addScoreBubble.getChildByName("num").setString(`+${score_add}%`)
  
    // self.addScoreBubble = cc.Sprite.createWithSpriteFrameName("commonLib/com_bigpop_bg.png")
    // self.scorePanel.addChild(self.addScoreBubble)
    // self.addScoreBubble.setVisible(false)
    // self.addScoreBubble.setPosition(-160,80)

    // self.getChildByName("score_team")
    var scoreTxt = scorePanel.getChildByName("scoreTxt")
    // scoreTxt.ignoreContentAdaptWithSize(true)
    // scoreTxt.setString(getText("level.success.score.text"))
    var score = scorePanel.getChildByName("txt_success")
    score.ignoreContentAdaptWithSize(true)
    //score.setPositionX(score.getPositionX() + 20)
    score.setString(tostring(self.score))
    score.getVirtualRenderer().setAdditionalKerning(-2)
    score.setPositionX(scoreTxt.getPositionX() + scoreTxt.getContentSize().width)
    var size = score.getVirtualRendererSize()
    //  奖励Tip
    // var propDeco = self.getChildByName("propDeco")
    // propDeco.setPositionX(propDeco.getPositionX() + 20)

    //  关闭按钮
    var close = UIGroupButton.create(self.getChildByName("btn_close"))
    ButtonPushBounceAnim.create(close)
    close.on(UIButtonEvent.Click, function () {
        if (self.isBusy) {
            return
        }
        if (self.checkRequestSubscribeSystemMessage()){
            return
        }
        self.dispatchNextEvent(true)
    })
    //  双倍奖励按钮
    // self.button = UIGroupButton.create(cc.CSLoader.createNode("cocos/panel_success_btn_orange.csb").getChildByName("button")); 
    // self.addChild(self.button)
    // self.button.setPosition(-200, 300)

    let buttonAni = cc.CSLoader.createNode("cocos/panel_success_btn_orange.csb")
    buttonAni.setPosition(-150, uiPos.button)
    self.addChild(buttonAni)
  
    self.button = UIGroupButton.create(buttonAni.getChildByName("button")); 
    // PushBounceAnim.create(self.button)
    buttonAni.actionTimeLine = cc.CSLoader.createTimeline("cocos/panel_success_btn_orange.csb");
    buttonAni.runAction(buttonAni.actionTimeLine)
    self.buttonAni = buttonAni
    // UIGroupButton.create(self.getChildByName("button").getChildByName("button"));
    // self.button.width = 232;
    // self.button.height = 120;
    // self.button.getChildByName("label").setVisible(false);
    var text = self.button.getChildByName("label");
    // text.setString("双倍奖励");
    self.button.text = text;
    // var size = text.getContentSize()
    // var normal = self.button.getChildByName("normal")
    // var bgSize = normal.getContentSize()
    // var y = text.getPositionY()
    // text.setPosition(-size.width / 2, y + 2)
    self.button.on(UIButtonEvent.Click, function () {
        self.clickDoubleReward();
        // 优化 去掉二次确认弹框
        // DYAdUtil.showAdSecondConfirmPanel(()=>{
        // });
    });
    self.ttUseDiamond = UserManager.getInstance().getTTSmallAmountUseDiamond()
    self.tt_buuble = TTUtil.addSmallPayBubble(self.button,(ttUseDiamond)=>{
        self.ttUseDiamond = ttUseDiamond
    },{
        type: "level_bonus",
        levelId: self.levelId,
        session: DCAssist.playLevelSession,
    },{
        fixPos: cc.p(0,-30) 
     })
    
    //  双倍次数文本
    self.doubleTxt =  cc.Label.createWithSystemFont("今日剩余" + (self.rewardConfig.times) + "次", "Arial", 24)
    self.doubleTxt.setPosition(self.buttonAni.x, self.buttonAni.y - 70)
    
    self.doubleTxt.setTextColor(cc.c4b(177, 115, 68, 255))
    self.doubleTxt._setFontWeight("bold");
    self.doubleTxt.setVisible(false)
    // oppo需要增加标识
    // if (window.mini && mini.getPlatform() === MiniPlatform.oppoQuickgame) {
    //     if (SnsProxy.getInstance().allowShare()) {
    //         self.button.ttAddBtnFlag(2, cc.p(-7, 3));
    //         text.setNextFontPositionXOffset(-3)
    //     } else {
    //         self.button.ttAddBtnFlag(1, cc.p(-7, 3));
    //         text.setNextFontPositionXOffset(-3)
    //     }
    // }
    // if (window.mini && mini.getPlatform() == MiniPlatform.tt){
    //     if (!self.rewardConfig.isGetShareRewardMax && !self.rewardConfig.isGetShareReward && self.rewardConfig.isGetEnergyMax && SnsProxy.getInstance().allowShare()){
    //         self.button.ttAddBtnFlag(2, cc.p(-7, 3));
    //         text.setNextFontPositionXOffset(-3)
    //     }else{
    //         // 调用看广告逻辑
    //         self.button.ttAddBtnFlag(1, cc.p(-7, 3));
    //         text.setNextFontPositionXOffset(-3)
    //     }
    // }
// return
    //  下一关按钮
    // self.getChildByName("btn_nextLevel").setVisible(false)

    let nextButtonAni = cc.CSLoader.createNode("cocos/panel_success_btn_green.csb")
    nextButtonAni.setPosition(150, uiPos.button)
    self.addChild(nextButtonAni)
    self.nextButton = UIGroupButton.create(nextButtonAni.getChildByName("showoff")); 
    nextButtonAni.actionTimeLine = cc.CSLoader.createTimeline("cocos/panel_success_btn_green.csb");
    nextButtonAni.runAction(nextButtonAni.actionTimeLine)
    self.nextButtonAni = nextButtonAni
    
    // self.nextButton = UIGroupButton.create(cc.CSLoader.createNode("cocos/panel_success_btn_green.csb").getChildByName("showoff")); 
    // self.addChild(self.nextButton)
    // self.nextButton.setPosition(200, 300)
    // UIGroupButton.create(self.getChildByName("showoff").getChildByName("showoff"));
    // self.nextButton.setAnchorPoint(0.5, 0.5);
    // var size = self.nextButton.getContentSize();
    // self.nextButton.x += size.width / 2;
    // self.nextButton.y += size.height / 2;
    
    text = self.nextButton.getChildByName("label");
    text.setAnchorPoint(0.5, 1)
    text.x = 5
    // var line = self.nextButton.getChildByName("line");
    // line.setScale(line.getScale() * 0.7)
    // line.x += 22
    // line.y += 10
    var levelID = tonumber(self.levelId)
    var showOnceAgain = false
    let isMainLevel = LevelType.isMainLevel(levelID)
    if (isMainLevel) {
        //当前关是通行证指定关，显示下一关
        if (BattlePassLogic.getInstance().isAssignedLevelandClickedBtn(levelID)
        || LightningRushManager.getInstance().isAssignedLevelandClickedBtn(levelID)
        || ShardCollectLogic.getInstance().isAssignedLevelandClickedBtn(levelID)){
            showOnceAgain = false
        }else if (type(oldStar) === "number" && oldStar > 0) {
            showOnceAgain = true
        }
    }
    // text.width += 100;
    // text.x += -50;
    // text.setFontSize(28);
    // text.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
    if (showOnceAgain) {
        //  再来一次
        text.setString(getText("level_bonus_text2"))
        // var touchSize = cc.size(200, 100);
    } else {
        //  下一关
        text.setString(getText("level_bonus_text1"))
        // var touchSize = cc.size(600, 100);
    }
    // self.nextButton.setContentSize(touchSize);
    // text.x += (touchSize.width - size.width) / 2;
    // text.y += (touchSize.height - size.height) / 2;
    // self.nextButton.getChildByName("line").x += (touchSize.width - size.width) / 2;
    // self.nextButton.getChildByName("line").y += (touchSize.height - size.height) / 2;
    //self.nextButton.x += touchSize.width / 2;
    //self.nextButton.y += touchSize.height / 2;
    self.nextButton.on(UIButtonEvent.Click, function(){
        if (self.isBusy) {
            return
        }
        if (self.checkRequestSubscribeSystemMessage(()=>{
            self.dispatchNextEvent()
        })){
            return
        }
        self.dispatchNextEvent()
    })
    //  奖励节点
    // self.rewardNode = cc.Node.create()
    //  求超越按钮
    var supportShowoff = SnsProxy.getInstance().allowShare()
    self.showoff = UIGroupButton.create(self.scorePanel.getChildByName("bubble_team"), true)
    ButtonPushBounceIdleBubbleAnim.create(self.showoff)
    let isShow, rewardBg, propItems
    // var text = self.showoff.getChildByName("label")
    // if (isWechatGameEnv()) {
    //     text.setString(getText("win.panel.challenge.button"))
    // }

    // var size = text.getVirtualRendererSize()
    // var normal = self.showoff.getChildByName("normal")
    // var bgSize = normal.getContentSize()
    // text.setPositionX(-size.width / 2)
    //text.y = 22
    UserLocalSettings.setSetting("challengeGuide_apear", 0)
    self.clickShowoff = function() {
        cc.log("clickShowoff");
        if (self.challengePanel){
            if (self.challengePanel.mask)self.challengePanel.mask.removeFromParent();
            if (self.challengePanel.bubble)self.challengePanel.bubble.removeFromParent();
            if (self.challengePanel.skipTxt)self.challengePanel.skipTxt.removeFromParent();
            self.challengePanel = null;
        }
        self.dispatchEvent(table([1, "name", WinPanelEvent.ShareMessage], [1, "needAnim", isShow], [1, "rewardBd", rewardBg], [1, "showoffType", self.showoffType]))
        // DCAssist.dc4TapPassLevelToShare(levelId)
        
        if (META.platform != XcloverPlatform.wechatgame) {
            DCAssist.dc4Share("feed_passLevelShare")
        }   
    }


    let panel_sandbeach_02 = cc.Sprite.createWithSpriteFrameName("panel_success/panel_sandbeach_02.png")
    panel_sandbeach_02.y = uiPos.sand
    panel_sandbeach_02.setLocalZOrder(-1)
    self.addChild(panel_sandbeach_02)
    self.panel_sandbeach_02 = panel_sandbeach_02
    // let pf = isWechatGameEnv() ? mini.getPlatform() : META.platform
    // if (DYAdUtil.isOpen() && pf == "douyin_game"){ //这里为了紧急上线 后续需要修改
    //     self.nextButton.setVisible(false);
    //     // if (showOnceAgain) {
    //     //     text.setString("再玩一次")
    //     // }else{
    //     //     text.setString("下一关")
    //     // }
    //     let x_right = self.showoff.x;
    //     let x_left = self.button.x;
    //     self.showoff.x = x_left;
    //     self.button.x = x_right;
    //     self.doubleTxt.x = x_right - self.doubleTxt.width/2;

    //     // DYAdUtil.modifyBtnSize(this.showoff,cc.size(260,120))
    //     // DYAdUtil.modifyBtnSize(this.button,cc.size(260,120))
    //     let icon_ad = DYAdUtil.addAdIcon(self.button);
    //     self.button.icon_ad = icon_ad;
    //     icon_ad.setPosition(icon_ad.width/2 + 26 - self.button.width/2 ,10);
    //     // self.button.text.setPosition(icon_ad.width + 30 -self.button.width/2,self.button.text.y - 5);
    //     // self.button.text.scale = 0.8;
    //     // text.scale = 0.85;
    //     // text.setPosition( -text.width/2*0.85 - 5, text.y - 5);
    //     // 在抖音中这个按钮功能变成下一关
    //     self.showoff.on(UIButtonEvent.Click, ()=>{
    //         if (self.isBusy) {
    //             return
    //         }
    //         self.dispatchNextEvent()
    //     })

    // }else{
        // if (pf == "wechatgame"){//这里为了紧急上线 后续需要修改
            // DYAdUtil.modifyBtnSize(this.button,cc.size(260,120))
            // let icon_ad = DYAdUtil.addAdIcon(self.button);
            // icon_ad.setScale(0.65)
            self.button.icon_ad = self.button.getChildByName("ad_orange_icon");
            // icon_ad.setPosition(icon_ad.width/2 - self.button.width/2 + 10 ,10);
            // self.button.text.setPosition(icon_ad.width - self.button.width/2, self.button.text.y);
            // self.button.text.scale = 0.8;
            // this.button.scale = 0.9
            // let x_old = self.button.x - 20;
            // this.button.x = x_old
            // self.doubleTxt.x = x_old - self.doubleTxt.width/2;
        // }

        self.showoff.on(UIButtonEvent.Click, self.clickShowoff)
    // }

    if (!__IOS_NOT_AUDIT || !supportShowoff ||  LevelType.isMysteryIslandLevel(self.levelId)){//神秘岛没有求超越
        //审核状态下不显示分享
        // var {x: bx, y: by} = self.button.getPosition()
        // self.button.setPosition(bx + 140, by)
        // self.doubleTxt.x = self.button.x - self.doubleTxt.width/2
        self.showoff.setVisible(false)
    }
    let [isOpen,limit] = AdTagManager.getInstance().getAdStrategyByAdType(AdTagManager.AdType.level_bonus)
    if (!isOpen && Number(self.rewardConfig.times) <= 0){
        console.log(`[AdTag] 结算双倍广告限制 isOpen=${isOpen}`)
        self.button.setVisible(false)
        if (self.tt_buuble) self.tt_buuble.setVisible(false)
        self.doubleTxt.setVisible(false)
        self.nextButtonAni.x = 0
    }
    if (self.button.isVisible()){
        DCAssist.dc4User101("level_bonus","ad_button_show",{session: `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`})
    }

    // self.rewardNode.setCascadeOpacityEnabled(true)
    // self.addChild(self.rewardNode)
    // self.buildRewardProps()
    // let prop = self.getChildByName("prop_shadow")
    // self.rewardNode.setPosition(cc.p(prop.getPositionX() + prop.getContentSize().width / 2, prop.getPositionY() - prop.getContentSize().height / 2))
    const isMystery = LevelType.isMysteryIslandLevel(self.levelId);
    if(UserManager.getInstance().supportMedal() && !isMystery) {
        MedalRankManager.getInstance().getLevelScoreRankList(self.levelId).then((data)=>{
            if(data) {
                self.buildRank(data);
            } else {
                self.buildRank(null); 
            }
        }).catch(()=>{
            self.buildRank(null);
        })
    } else {
        self.buildRank(null);
    }

    //  顶部标题
    // self.title = self.getChildByName("title")
    self.isHardLevel = isHardLevel
    // if (!isHardLevel) {
    //     let path = "adapter/" + he.MetaInfo.getLanguage() + "/level_panel_win_letter.png"
    //     var title = cc.Sprite.create(path)
    //     title.setPosition(self.title.getPosition())
    //     title.setAnchorPoint(self.title.getAnchorPoint())
    //     self.title.removeFromParent(true)
    //     self.title = title
    //     self.addChild(self.title)
    //     self.setScale(self.getReferenceScale())
    // }
    // self.title.setAnchorPoint(cc.p(0.45, self.title.getAnchorPoint().y))
    // self.title.setPositionX(self.getChildByName("bg").getContentSize().width / 2)
    self.on(WinPanelEvent.FinishAnim, function (event) {
        self.isAnimFinished = true
        self.recordData()
    })

    
    self.passlevelShowoffGuideTimes = 3;
    self.passlevelShowoffNum = 3;
    self.passlevelShowoffLevel = 6; 
    self.passlevelRankOverLevel = 0 //真假挑战，分数超越限制关卡
    self.passLevelShowoffFirstplace = "2:0,6:1,9999:-1";
    CfgManager.load("game").then(()=>{
        var config = CfgManager.get("game");
        self.passlevelShowoffGuideTimes = config.passlevel_showoff_guide_times;
        self.passlevelShowoffNum = config.passlevel_showoff_num;
        self.passlevelShowoffLevel = config.passlevel_showoff_level;
        //a分组读配置，默认为0
        if (UserManager.getInstance().groupTestInfoByKey("passLevelShowOff") == "a"){
            self.passlevelRankOverLevel = config.passlevel_rankover_level;
        }
        self.passLevelShowoffFirstplace = config.passlevel_showoff_firstplace;

        CfgManager.release("game");
    }).catch((err) => {
        console.error("load game config failed!", err);
    });

    self.raccoon = self.getChildByName("dec_raccoon");

    DCAssist.dc4User101("level_bonus", "icon_show", {current_stage:self.levelId});

    self.dc4ShareBtnShow();

    DCAssist.dc4ShareShow("passlevel_challenge");

    // 海滨之心收集显示
    this.ssManager = SeasideStarManager.getInstance()

    // self.initSeasideStarUI()
    if(medalData) {
        self.medalRankData = medalData;
        let node = cc.CSLoader.createNode("cocos/rank_medal.csb");
        node.setScale(1.93 * 0.4);
        self.addChild(node);
        node.setPosition(-250, uiPos.score - 30);
        let rank = node.getChildByName("label");
        rank.setNextFontPositionXOffset(-8);
        rank.setString("" + medalData.rank);
        if(medalData.panel) {
            node.setVisible(false);
            medalData.panel.on(BasePanelEvent.Close, function () {
                medalData.panel = null;
                node.setVisible(true);
            });
        }
        quickBuildUIButton(node, () =>{
            self.isBusy = true;
            medalData.type = "stage_end";
            medalData.session = DCAssist.dcForStartGameParams.session;
            MedalRankManager.getInstance().openStartPanel(medalData,() => {
                self.isBusy = false;
            })
            //
            let params = {
                session: DCAssist.dcForStartGameParams.session,
                current_stage: self.levelId,
                record: medalData.rank,
                num:  medalData.count,
                click_type: "rank_icon",
            }
           MedalRankManager.getInstance().dcSimple("stage_end_rank_click", params);
        })
    }
    self.fitScreen()

    
    self.initLevelRewards()
    self.initActivityRewards()
    self.initGoldElysiumUI()
    self.showWaterFighting()

    self._kMedalRankOpen = function (event) {
        let show = true;
        if (event.data && event.data.show == true) {
            show = false;
        }
        self.setVisible(show);
    }
    GlobalEventDispatcher.getInstance().addEventListener(
        kGlobalEvents.kMedalRankOpen,
        self._kMedalRankOpen,
    );
}
const Interval = 150
WinPanel.prototype.initLevelRewards = function() {
    let self = this
    // let templete = self.getChildByName("prop_shadow")
    // templete.setVisible(false)

    let part = cc.CSLoader.createNode("cocos/panel_success_award_team.csb")
    part.y = uiPos.level
    self.addChild(part)
    

    self.levelPartNode = part
    self.levelPartNode.setOpacity(0)

    self.levelPartRewardsNode = table()

    let title = cc.Label.createWithSystemFont((self.button && !self.button.visible) ? "过关获得" : "看视频可翻倍", "Arial", 24)
    title.setTextColor(cc.c4b(177, 115, 68, 255))
    title._setFontWeight("bold")
    title.setPosition(0, -60)
    title.setPosition(part.getChildByName("iconplaceholder").getPosition())
    part.addChild(title)



    let templeteItem =  part.getChildByName("award")
    templeteItem.setVisible(false)


    table.each(self.totalRewards, function(v, k) {
        // var v = self.totalRewards[i]
        // if (!v) {
        //     continue
        // }
        if ($null(v)) return
        let box = cc.CSLoader.createNode("cocos/panel_success_award.csb")
        box.setPosition(templeteItem.getPosition())
        self.levelPartNode.addChild(box)
        box.x += Interval * (tonumber(k) - 1) - ($len(self.totalRewards) - 1) * Interval / 2
        box.setCascadeOpacityEnabled(true)
        // var reward = cc.CSLoader.createNode("cocos/panel_success_reward.csb");
        // reward.rewardAnim = cc.CSLoader.createTimeline("cocos/panel_success_reward.csb");

        // reward.setAnchorPoint(cc.p(0.5, 0.5))
        // reward.setCascadeOpacityEnabled(true)
        // prop = reward.getChildByName("icon");

        let numlabel = cc.Label.createWithSystemFont("x" + v.num, "Arial", 24)
        numlabel.setTextColor(cc.c4b(177, 115, 68, 255))
        numlabel._setFontWeight("bold")
        numlabel.setPosition(-5, -50)
        box.numlabel = numlabel
        box.addChild(numlabel)
        box.originNum = v.num
        
        box.getChildByName("iconplaceholder").setScale(0.8)
        box.getChildByName("iconplaceholder").setSpriteFrame(UIItemBuilder.createPropIcon(v.itemId).getSpriteFrame());
        box.getChildByName("iconplaceholder").y += 10
        box.getChildByName("num").setVisible(false)
        box.getChildByName("bubble_num").setVisible(false)

        table.insert(self.levelPartRewardsNode, box)
        // 微信分享奖励翻倍，奖励图标需要增加动画配置
        // reward.rewardItem = {}
        // reward.rewardItem.itemId = tonumber(v.itemId)
        // reward.rewardItem.num = tonumber(v.num)
        // var sSize = prop.getContentSize()
        // prop.setScale(size.height / sSize.height * 2 / 5)
        // var label = reward.getChildByName("numb_old").getChildByName("label");
        // var newLabel = reward.getChildByName("numb_new").getChildByName("label");
        // label.setString(reward.rewardItem.num);
        // newLabel.setString(reward.rewardItem.num * 2);
        // reward.setVisible(false)
        // reward.setPosition(cc.p((i - 0.5) * size.width * 0.8 / $len(self.totalRewards) - size.width * 0.8 / 2 + 10 + size.width * 0.1, 0))
        // self.rewardNode.addChild(reward, 30)
        // table.insert(self.rewards, table(
        //     [1, "prop", prop],
        //     [1, "label", label],
        //     [1, "newLabel", newLabel],
        //     [1, "layer", reward]
        // ))
    })
    // self.levelPartNode.setCascadeOpacityEnabled(true)
  
}
WinPanel.prototype.initGoldElysiumUI = function() {
    let self = this
    let mgr = GoldElysiumManager.getInstance()
    if (!mgr.isNeedWinPanelProgress()) return
    let mData = mgr.getData()
    let goldElysiumNode = cc.CSLoader.createNode("cocos/gold_elysium_progress.csb")
    self.addChild(goldElysiumNode)
    // self.panel_sandbeach_02.setVisible(false)
    goldElysiumNode.y = self.panel_sandbeach_02.y - 230
    let needNum = mData.getWinningStreakNeed()
    let curNum =  mData.getWinningStreak()
    goldElysiumNode.getChildByName("label2").setString(`${curNum}/${needNum}`)
    let progress_node = goldElysiumNode.getChildByName("progress_node")
    let tempLine = progress_node.getChildByName("line1")
    tempLine.setVisible(false)
    let nodeWidth = 462 / needNum
    progress_node.getChildByName("bar").width = curNum/needNum* 462
    
    for (let i = 1; i <= needNum; i++) {
        let node = node = cloneUINode(tempLine)
        progress_node.addChild(node)
        node.setVisible(true)
        node.x = i*nodeWidth
        node.y = -18
        if (i >= curNum){
            node.setSpriteFrame(cc.spriteFrameCache.getSpriteFrame("gold_elysium_progress/gold_elysium_progress4.png" ))
        }

    }

}
WinPanel.prototype.initActivityRewards = function() {
    let self = this
    
    // let templete = self.getChildByName("prop_shadow")
    // templete.setVisible(false)


    if ($len(self.activityRewards) == 0){ //调整面板位置
        let bottomAddY = 90
        self.scorePanel.y -= 25
        self.levelPartNode && (self.levelPartNode.y += 140)
        table.each(self.levelPartRewardsNode, function(v, k){
            v && (v.y -= 20)
        })


        self.panel_sandbeach_02.y += bottomAddY
        self.buttonAni.y += bottomAddY
        self.nextButtonAni.y += bottomAddY
        self.doubleTxt.y += bottomAddY
        return
    } 


    let part = cc.CSLoader.createNode("cocos/panel_success_award_team.csb")
    part.y = uiPos.activity
    self.addChild(part)
    self.activityPartNode = part
    self.activityPartNode.setOpacity(0)
    self.activityPartRewardsNode = table()

    let title = cc.Label.createWithSystemFont("活动奖励", "Arial", 24)
    title.setTextColor(cc.c4b(177, 115, 68, 255))
    title._setFontWeight("bold")
    title.setPosition(0, -60)
    title.setPosition(part.getChildByName("iconplaceholder").getPosition())
    part.addChild(title)



    let templeteItem =  part.getChildByName("award")
    templeteItem.setVisible(false)
    table.each(self.activityRewards, function(v, k) {
        // var v = self.activityRewards[i]
        // if (!v) {
        //     continue
        // }
        if ($null(v)) return
        let box = cc.CSLoader.createNode("cocos/panel_success_award.csb")
        box.setPosition(templeteItem.getPosition())
        templeteItem.getParent().addChild(box)
        box.x += Interval * (tonumber(k) - 1) - ($len(self.activityRewards) - 1) * Interval / 2

        // var reward = cc.CSLoader.createNode("cocos/panel_success_reward.csb");
        // reward.rewardAnim = cc.CSLoader.createTimeline("cocos/panel_success_reward.csb");

        // reward.setAnchorPoint(cc.p(0.5, 0.5))
        box.setCascadeOpacityEnabled(true)
        // prop = reward.getChildByName("icon");

        let numlabel = cc.Label.createWithSystemFont("x" + v.num, "Arial", 24)
        numlabel.setTextColor(cc.c4b(177, 115, 68, 255))
        numlabel._setFontWeight("bold")
        numlabel.setPosition(-5, -50)
        box.numlabel = numlabel
        box.addChild(numlabel)
        box.originNum = v.num
        //
        if (v.text) {
            let textBg = ccui.Scale9Sprite.createWithSpriteFrameName("panel_success/bubble_num.png", cc.rect(18, 14, 8, 4));
            textBg.width = 80;
            textBg.setPosition(cc.p(35, 42));
            box.addChild(textBg);

            let txtlabel = cc.Label.createWithSystemFont(v.text, "Arial", 24);
            txtlabel._setFontWeight("bold");
            box.addChild(txtlabel);
            txtlabel.setPosition(35, 44);
        }
        
        box.getChildByName("iconplaceholder").setSpriteFrame(v.image);
        box.getChildByName("iconplaceholder").y += 10
        box.getChildByName("num").setVisible(false)
        box.getChildByName("bubble_num").setVisible(v.times > 1)
        box.getChildByName("bubble_num").setVisible(false)

        let qipao = QuickCreateAnimNode("cocos/panel_success_qipao.csb")
        qipao.setPosition(box.getChildByName("bubble_num").getPosition())
        let timeslabel = cc.Label.createWithSystemFont( v.times + "倍", "Arial", 24)
        // // timeslabel.setTextColor(cc.c4b(255, 255, 68, 255))
        timeslabel._setFontWeight("bold")
        timeslabel.setPosition(30, 10)
        qipao.getChildByName('jiedian').addChild(timeslabel)
        // timeslabel.setOpacity(0)
        // timeslabel.runAction(cc.FadeIn.create(0.2)) 
        qipao.timeslabel = timeslabel
        box.addChild(qipao)
        box.qipao = qipao
        box.timesNum = v.times
        qipao.actionTimeLine.gotoFrameAndPlay(0, 10, false)
        qipao.setVisible(v.times > 1)
        // qipao.timeslabel.runAction(cc.FadeIn.create(0.05)) 
        // v.qipao.actionTimeLine.gotoFrameAndPlay(0, 10, false)

        table.insert(self.activityPartRewardsNode, box)
        // box.getChildByName("bubble_num").getChildByName("num").setString("x" + v.times)
        // 微信分享奖励翻倍，奖励图标需要增加动画配置
        // reward.rewardItem = {}
        // reward.rewardItem.itemId = tonumber(v.itemId)
        // reward.rewardItem.num = tonumber(v.num)
        // var sSize = prop.getContentSize()
        // prop.setScale(size.height / sSize.height * 2 / 5)
        // var label = reward.getChildByName("numb_old").getChildByName("label");
        // var newLabel = reward.getChildByName("numb_new").getChildByName("label");
        // label.setString(reward.rewardItem.num);
        // newLabel.setString(reward.rewardItem.num * 2);
        // reward.setVisible(false)
        // reward.setPosition(cc.p((i - 0.5) * size.width * 0.8 / $len(self.activityRewards) - size.width * 0.8 / 2 + 10 + size.width * 0.1, 0))
        // self.rewardNode.addChild(reward, 30)
        // table.insert(self.rewards, table(
        //     [1, "prop", prop],
        //     [1, "label", label],
        //     [1, "newLabel", newLabel],
        //     [1, "layer", reward]
        // ))
    })



    
}
WinPanel.prototype.initSeasideStarUI = function() {
    this.seasideStarNode = this.getChildByName("shouji_bg")
    if (!this.ssManager.isOpen()){
        this.seasideStarNode.setVisible(false)
        return
    }
    DCAssist.dc4User101("coast_star","stage_end_pageshow")

    this.btn_use_double_card = this.seasideStarNode.getChildByName("btn_use") //使用双倍卡
    this.btn_vedio_double = this.seasideStarNode.getChildByName("btn_vedio") 
    this.btn_use_double_card.getChildByName("label").x += 5
    this.btn_vedio_double.getChildByName("tx_use").setString("  双倍")
    let icon_ad = DYAdUtil.addAdIcon(this.btn_vedio_double);
    icon_ad.setScale(0.6)
    icon_ad.x -= 50
    icon_ad.y += 3
    // if (LevelType.isMysteryIslandLevel(this.levelId)){
    //     this.coastStarNum = this.ssManager.calculateGetNum(0,1,GameBoardLogic.instance.itemAnimalDestoryCountMap)
    // }else{
    //     this.coastStarNum = this.ssManager.calculateGetNum(this.oldStar,this.star,GameBoardLogic.instance.itemAnimalDestoryCountMap)
    // }
    this.coastStarNum = this.ssManager.getRealCollectNum()
    DCAssist.dc4User101("coast_star","colection",{num:this.coastStarNum,type:"1"})

    this.ssManager.recordCollectNum(this.coastStarNum)
    if (this.coastStarNum <= 0){
        this.seasideStarNode.setVisible(false)
        return
    }
    quickBuildBtn(this.btn_use_double_card, UIGroupButton, PushBounceAnim, () => {
        if (this.isBusy) {
            return
        }
        this.isBusy = true
        DCAssist.dc4User101("coast_star","stage_end_pageclick",{scence:"double_card"})
        if (this.ssManager.getDoubleCardNum() <= 0){
            Toast.make(getText("error.tip.761974"))
            this.isBusy = false
            return
        }
        this.ssManager.bonusCollect(2,this.coastStarNum,()=>{
            this.isSeasideStarDouble = true
            this.isBusy = false
            this.refreshSeasideStarUI()
            this.ssManager.recordCollectNum(this.coastStarNum*2)
        },()=>{
            this.isBusy = false
        })
    }, true);
    quickBuildBtn(this.btn_vedio_double, UIGroupButton, PushBounceAnim, () => {
        DCAssist.dc4User101("coast_star","stage_end_pageclick",{scence:"video_double"})
        // DYAdUtil.showAdSecondConfirmPanel(()=>{
            this.isSeasideStarDouble = true
            if (this.ssManager.getWatchAdLeft() <= 0){
                Toast.make(getText("视频翻倍次数已用完！"))
                return
            }
            this.showSeasideStarDoubleAd(()=>{
                this.ssManager.bonusCollect(1,this.coastStarNum,()=>{
                    this.ssManager.recordCollectNum(this.coastStarNum*2)
                    this.refreshSeasideStarUI()
                })
            })
        // });
    }, true);

    let collectStr = "本次共收集棋子"
    this.seasideStarNode.getChildByName("chuanzhang").setVisible(false)
    if (this.ssManager.getPlayCalculateGetNum(GameBoardLogic.instance.itemAnimalDestoryCountMap) <= 0){
        collectStr = "你获得了船长赠送的棋子"
        this.seasideStarNode.getChildByName("chuanzhang").setVisible(true)
    }
    this.collectLable1 = cc.LabelBMFont.create(collectStr, "font/zzgftongxin_40.fnt")
    this.collectLable2 = cc.LabelBMFont.create("1111", "font/zzgftongxin_40.fnt")
    this.collectLable3 = cc.LabelBMFont.create("枚", "font/zzgftongxin_40.fnt")
    this.collectShowNode =  cc.Node.create();
    this.collectShowNode.addChild(this.collectLable1)
    this.collectShowNode.addChild(this.collectLable2)
    this.collectShowNode.addChild(this.collectLable3)
    this.seasideStarNode.addChild(this.collectShowNode)
    this.collectShowNode.setPosition(cc.p(0,45))
    this.collectShowNode.scale = 0.6
    this.collectLable2.setColor(cc.color(255, 255, 0, 255))
    // node.setAnchorPoint(0.5, 0.5);

    // 翻倍后共收集棋子20枚~
    this.doubleLable1 = cc.LabelBMFont.create("翻倍后共收集棋子", "font/zzgftongxin_40.fnt")
    this.doubleLable2 = cc.LabelBMFont.create("1111", "font/zzgftongxin_40.fnt")
    this.doubleLable3 = cc.LabelBMFont.create("枚~", "font/zzgftongxin_40.fnt")
    this.doubleLable1.setAnchorPoint(0, 0.5)
    this.doubleLable2.setAnchorPoint(0, 0.5)
    this.doubleLable3.setAnchorPoint(0, 0.5)
    this.doubleLable1.setPosition(cc.p(-70,25))
    this.doubleLable2.setPosition(cc.p(-70,-25))
    this.doubleLable3.y = -25

    this.doubleShowNode = cc.Node.create();
    this.doubleShowNode.addChild(this.doubleLable1)
    this.doubleShowNode.addChild(this.doubleLable2)
    this.doubleShowNode.addChild(this.doubleLable3)
    this.doubleLable2.setColor(cc.color(255, 255, 0, 255))
    let img_chicken = this.seasideStarNode.getChildByName("img_chicken")
    img_chicken.x = img_chicken.x + 30

    this.seasideStarNode.addChild(this.doubleShowNode)
    this.doubleShowNode.scale = 0.6

    let cardLabel = this.seasideStarNode.getChildByName("tx_sy")
    let videoLabel = this.seasideStarNode.getChildByName("tx_times01")
    cardLabel.y = cardLabel.y - 10
    videoLabel.y = videoLabel.y - 10

    this.refreshSeasideStarUI()
}
WinPanel.prototype.refreshSeasideStarUI = function() {
    let img_chicken = this.seasideStarNode.getChildByName("img_chicken")
    let cardLabel = this.seasideStarNode.getChildByName("tx_sy")
    let videoLabel = this.seasideStarNode.getChildByName("tx_times01")
    videoLabel.string = `本日还有${this.ssManager.getWatchAdLeft()}次`
    cardLabel.string = `剩余${this.ssManager.getDoubleCardNum()}张`


    
    this.seasideStarNode.getChildByName("tx_02").setVisible(false)
    this.seasideStarNode.getChildByName("tx_01").setVisible(false)
    img_chicken.setVisible(false)
    cardLabel.setVisible(false)
    videoLabel.setVisible(false)
    this.collectShowNode.setVisible(false)
    this.doubleShowNode.setVisible(false)

    if (this.isSeasideStarDouble){
        img_chicken.setVisible(true)
        this.btn_vedio_double.setVisible(false)
        this.btn_use_double_card.setVisible(false)

        this.doubleShowNode.setVisible(true)
        this.doubleLable2.string = this.coastStarNum *2
        this.doubleLable3.x = this.doubleLable2.x + this.doubleLable2.width
    }else{
        cardLabel.setVisible(true)
        videoLabel.setVisible(true)
        this.collectShowNode.setVisible(true)
        this.collectLable2.string = this.coastStarNum
        this.collectLable1.x = -(this.collectLable2.width/2+this.collectLable3.width/2)
        this.collectLable2.x = this.collectLable1.x + this.collectLable1.width/2 + this.collectLable2.width/2
        this.collectLable3.x = this.collectLable2.x + this.collectLable2.width/2 + this.collectLable3.width/2
    
    }

    if (!this.ssManager.getIsSupportShare()){
        this.btn_vedio_double.x = 0
        videoLabel.x = 0 - videoLabel.width/2
        this.btn_use_double_card.setVisible(false)
        cardLabel.setVisible(false)
    }

}
/**
 * 播放激励视频 海滨之星
 */
WinPanel.prototype.showSeasideStarDoubleAd = function (successCb) {
    let self = this;

    if (self.isBusy) {
        return;
    }

    self.isBusy = true;
    DCAssist.dc4AdClick("coast_star", "coast_star_ad_click", {"current_stage": self.levelId});

    if (SnsProxy.getInstance().allowAd()) {
        SnsProxy.getInstance().prepareAd("SeasideStarDoubleCollect")
        .then(()=>{
            if (self.isClosed)
                return;
            playAd()
        },(err)=>{
            self.isBusy = false;
            if (!self.isClosed) {
                errorAdWatch(err)
            }
        })
        .catch(err=> {
            console.error("SeasideStarDoubleCollect prepare ad failed!", err);
            Toast.make(getText("level_bonus_tip_noAds"), 1, function () {
                self.isBusy = false;
            });
        })
    } else {
        Toast.make(getText("抱歉，当前无可观看的广告！"), 1, function () {
            self.isBusy = false;
        });
    }

    function errorAdWatch(err) {
        if (window.logCenter) {
            window.logCenter.log({
                message: "wx_video_ad passLevelDoubleReward onRewardedVideoAdError: " + JSON.stringify(err)
            });
        } else {
            cc.error("wx_video_ad passLevelDoubleReward onRewardedVideoAdError: " + err.errMsg);
        }  
        
        Toast.make(getText("level_bonus_tip_noAds"), 1, function () {});

        DCAssist.dc4AdNoMore("coast_star", "coast_star_ad_noads", {current_stage: self.levelId});
    }

    function dropoutAdWatch() {
        DCAssist.dc4AdDropOut("coast_star", "coast_star_ad_dropout", {"current_stage": self.levelId});
        Toast.make(getText("error.tip.dropout_ad"));
    }

    function fetchAdRewards() {
        // self.getDoubleReward(1);
        if (successCb) successCb()
        DCAssist.dc4AdFinish("coast_star", "coast_star_ad_finish", {
            current_stage: self.levelId
        });
    }

    function playAd() {
        //  播放广告
        SnsProxy.getInstance().showAd("SeasideStarDoubleCollect")
        .then(isEnd=> {
            if (!self.isClosed) {
                if (isEnd) {
                    //  成功看完广告
                    self.isBusy = false;
                    fetchAdRewards()
                } else {
                    //  中途退出
                    self.isBusy = false;
                    dropoutAdWatch()
                }
            }
        },(err)=>{
            self.isBusy = false;
            if (!self.isClosed) {
                errorAdWatch(err)
            }
        })
        .catch(err=> {
            self.isBusy = false;
            if (!self.isClosed) {
                errorAdWatch(err)
            }
        })
    }
}

//展示水枪活动对打
WinPanel.prototype.showWaterFighting = function () {
    let self = this;
    const levelId = self.levelId;
    //不校验新老关
    if (WaterFightingManager.getInstance().isOpen() && WaterFightingManager.getInstance().getActState() == 2) {
        WaterFightingManager.getInstance().getInfo().then((data) => {
            let newRecordInfos = data.newRecordInfos;
            if (newRecordInfos && $len(newRecordInfos)) {
                const WaterFightingWinBanner = require("../../activity/WaterFighting/WaterFightingWinBanner.js")
                let banner = WaterFightingWinBanner.show(self, data.playerInfos, data.newRecordInfos);
                //
                WaterFightingManager.getInstance().dcAttack(
                    newRecordInfos,
                    DCAssist.dcForStartGameParams.session,
                    levelId
                );
            }
        }).catch(() => {

        })
    }
}
/**
 * 点击双倍奖励按钮
 */
WinPanel.prototype.clickDoubleReward = function() {
    var self = this;

    if (self.isBusy) {
        return
    }
    self.isBusy = true;

    //  检查本次通关是否存在奖励，是否可以翻倍
    if ($len(self.totalRewards) <= 0) {
        Toast.make(getText("error.tip.760610"), 1, function () {
            self.isBusy = false;
        });
        return;
    }

    //  检查是否已领过奖
    if (self.rewardConfig.isGetThisReward) {
        self.isBusy = false;
        return;
    }

    let times = self.rewardConfig.times;
    let type = 0;
    let ad_type = null;
    if (times > 0) {
        //  还有次数，是否达到累计拉新量
        if (self.rewardConfig.isGetShareRewardMax) {
            //  达到累计拉新量
            self.isBusy = false;
            type = 1;
            ad_type = "click";
            self.showAd(true);
        } else {
            //  未达到累计拉新量
            if (self.rewardConfig.isGetShareReward) {
                //  已获取过分享奖励，调用看广告逻辑
                self.isBusy = false;
                type = 1;
                ad_type = "click";
                self.showAd(false);
            } else if (self.rewardConfig.isGetEnergyMax) {
                //  达到精力领取上线
                if (SnsProxy.getInstance().allowShare()) {
                    self.isBusy = false;
                    type = 0;
                    self.shareToGroup();
                } else {
                    self.isBusy = false;
                    type = 1;
                    ad_type = "click";
                    self.showAd(false);
                }
            } else {
                self.isBusy = false;
                type = 1;
                ad_type = "click";
                self.showAd(false);
            }
        }
    } else {
        //  没有次数了，检查是否可以继续提升上限
        if (self.rewardConfig.totalGetTimes < MetaManager.getPassLevelDoubleRewardTopTimes() && SnsProxy.getInstance().allowShare()) {
            type = 3;
            Toast.make(getText("level_bonus_tip2", { num: self.rewardConfig.levelUpNeedTimes}), 1, function () {
                self.isBusy = false;
            });
        } else {
            type = 2;
            Toast.make(getText("level_bonus_tip1"), 1, function () {
                self.isBusy = false;
            });
        }
    }

    // DCAssist.dc4User101("level_bonus", "icon_click", {
    //     current_stage: self.levelId,
    //     type: type,
    //     num: self.rewardConfig.getTimes,
    //     ad_type: ad_type,
    //     sub_level: self.rewardConfig.totalGetTimes,
    //     sub_id: MetaManager.getPassLevelDoubleRewardLimit(self.rewardConfig.totalGetTimes)
    // });
    if (ad_type){
        // 统一广告打点规范处理
        DCAssist.dc4AdClick("level_bonus", "icon_click", {
            current_stage: self.levelId,
            type: type,
            num: self.rewardConfig.getTimes,
            ad_type: ad_type,
            sub_level: self.rewardConfig.totalGetTimes,
            sub_id: self.rewardConfig.getTimes + self.rewardConfig.times
        })
    }else{
        DCAssist.dc4User101("level_bonus", "icon_click", {
            current_stage: self.levelId,
            type: type,
            num: self.rewardConfig.getTimes,
            ad_type: ad_type,
            sub_level: self.rewardConfig.totalGetTimes,
            sub_id: self.rewardConfig.getTimes + self.rewardConfig.times
        });
    }
    
}

/**
 * 发送分享
 */
WinPanel.prototype.shareToGroup = function  () {
    let self = this

    if (self.isBusy) {
        return;
    }
    self.isBusy = true;
    
    let resetBusy = ()=> self.isBusy = false;

    function onSuccess() {
        resetBusy();
        self.getDoubleReward(2);
    }

    function onCancel() {
        Toast.make(getText("level_bonus_tip_sharefailed"));
        resetBusy();
    }
    let dcData = { 
        current_stage: self.levelId, 
        num: (self.rewardConfig.getTimes+1), 
        sub_level: (self.rewardConfig.totalGetTimes+1), 
        sub_id: MetaManager.getPassLevelDoubleRewardLimit(self.rewardConfig.totalGetTimes + 1)
    }
    ShareUtil.clickLevelBonus(dcData, onSuccess, onCancel, onCancel);
}

/**
 * 播放激励视频
 */
WinPanel.prototype.showAd = function (ifFailUseShare = false) {
    let self = this;

    if (self.isBusy) {
        return;
    }

    self.isBusy = true;
    let http = ClientConfigHttp.new(false)//配置信息同步
    http.load()
    if (self.ttUseDiamond && TTUtil.isOpenSmallPay()){
        TTUtil.smallPay({
            session: DCAssist.playLevelSession,
            goodName:"关末双倍",
            levelId: self.levelId,
            type: "level_bonus"
        },()=>{
    
            self.getDoubleReward(1);
        },()=>{
            self.isBusy = false
        })
        return
    }
    if (SnsProxy.getInstance().allowAd()) {
        SnsProxy.getInstance().prepareAd("PassLevelDoubleReward")
        .then(()=>{
            if (self.isClosed)
                return;
            playAd()
        },(err)=>{
            self.isBusy = false;
            if (!self.isClosed) {
                errorAdWatch(err)
            }
        })
        .catch(err=> {
            console.error("PassLevelDoubleReward prepare ad failed!", err);
            Toast.make(getText("level_bonus_tip_noAds"), 1, function () {
                self.isBusy = false;
            });
        })
    } else {
        Toast.make(getText("抱歉，当前无可观看的广告！"), 1, function () {
            self.isBusy = false;
        });
    }

    function errorAdWatch(err) {
        if (window.logCenter) {
            window.logCenter.log({
                message: "wx_video_ad passLevelDoubleReward onRewardedVideoAdError: " + JSON.stringify(err)
            });
        } else {
            cc.error("wx_video_ad passLevelDoubleReward onRewardedVideoAdError: " + err.errMsg);
        }  
        
        if (ifFailUseShare && SnsProxy.getInstance().allowShare()) {
            self.shareToGroup();
        } else {
            Toast.make(getText("level_bonus_tip_noAds"), 1, function () {});
        }

        DCAssist.dc4AdNoMore("level_bonus", "ad_noAds", {current_stage: self.levelId, ad_type: "noAds"});
    }

    function dropoutAdWatch() {
        DCAssist.dc4AdDropOut("level_bonus", "ad_dropout", {"current_stage": self.levelId, "ad_type": "dropout"});
        Toast.make(getText("error.tip.dropout_ad"));
    }

    function fetchAdRewards() {
        self.getDoubleReward(1);
        DCAssist.dc4AdFinish("level_bonus", "ad_finish", {
            current_stage: self.levelId, 
            num: (self.rewardConfig.getTimes + 1),
            sub_level: (self.rewardConfig.totalGetTimes + 1),
            sub_id: self.rewardConfig.getTimes + self.rewardConfig.times
        });
    }

    function playAd() {
        //  播放广告
        SnsProxy.getInstance().showAd("PassLevelDoubleReward")
        .then(isEnd=> {
            if (!self.isClosed) {
                if (isEnd) {
                    //  成功看完广告
                    self.isBusy = false;
                    fetchAdRewards()
                } else {
                    //  中途退出
                    self.isBusy = false;
                    dropoutAdWatch()
                }
            }
        },(err)=>{
            self.isBusy = false;
            if (!self.isClosed) {
                errorAdWatch(err)
            }
        })
        .catch(err=> {
            self.isBusy = false;
            if (!self.isClosed) {
                errorAdWatch(err)
            }
        })
    }


}

/**
 * 获取双倍奖励
 */
WinPanel.prototype.getDoubleReward = function(source = 1) {
    var self = this;

    if (self.isBusy) {
        return;
    }

    self.isBusy = true;

    function onSuccess(evt) {
        self.rewardConfig.times -= 1;
        self.addDoubleReward(evt.data, source);
        self.isBusy = false;
        self.rewardConfig.isGetThisReward = true;
    }

    function onFail(evt) {
        if (evt && evt.data && evt.data.errorCode) {
            Toast.make(getText("error.tip." + evt.data.errorCode), 1, function () {
                self.isBusy = false;
            });
        } else {
            Toast.make(getText("error.tip.-1"), 1, function () {
                self.isBusy = false;
            });
        }
    }

    function onCancel(evt) {
        Toast.make("已取消。", 1, function () {
            self.isBusy = false;
        });
    }

    var http = GetLevelBonusRewardHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load({source: source});
}

/**
 * 添加双倍奖励
 */
WinPanel.prototype.addDoubleReward = function(data, source) {
    let self = this

    let rewardList = data.rewards;
    let dcData = {
        category: "ad",
        sub_category: "level_bonus" 
    }
    if (source == 2){//1为广告  2为分享
        dcData = {
            category: "share",
            sub_category: "level_bonus" 
        }
    }

    if ($len(rewardList) > 0) {
        for (var i = 1, v = rewardList[1]; v; i++, v = rewardList[i]) {
            UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.STAGE_REWARD_BONUS, {
                category: "ad",
                sub_category: "level_bonus"
            })
        }
    }

    self.doubleTxt.setString("今日剩余" + (self.rewardConfig.times) + "次");

    self.playDoubleRewardAnim();
}
function addNumAni(reward, times){
    if (times <= 1) return
    reward.numlabel.runAction(cc.Sequence.create(
        cc.ScaleTo.create(0.1,  1.5),
        
        cc.CallFunc.create(function( ){
            reward.numlabel.setString("x" + reward.originNum * times)
        }),
        // cc.DelayTime.create(0.2), 
        
        cc.ScaleTo.create(0.2, 1)
    ));
}
/**
 * 播放双倍奖励动画
 */
WinPanel.prototype.playDoubleRewardAnim = function () {
    let self = this;

    if (self.levelPartRewardsNode) {
        table.each(self.levelPartRewardsNode, function(v, k){
            addNumAni(v, 2)

        })

    }

    if (self.button) {
        if (self.button.icon_ad) self.button.icon_ad.setVisible(false);//加倍成功够 隐藏掉广告icon
        if (self.tt_buuble)self.tt_buuble.setVisible(false)

        let anim = cc.CSLoader.createTimeline("cocos/panel_success_btn_green_replay.csb");
        let text = self.button.getChildByName("label");
        text.setString(getText("level_bonus_pictext1"));
        text.x += 12;
        if (DYAdUtil.isOpen()){
            text.x = - text.width/2 + 10;
        }
        anim.gotoFrameAndPlay(28, 48, 28, false);
        self.button.runAction(anim);
    }
}

WinPanel.prototype.cleanup = function () {
    var self = this
    self.friendRank_panel = null;
    BasePanel.prototype.cleanup.call(self)
}
/**
 * 整理奖励列表
 */
WinPanel.prototype.mergeRewards = function (rewardList) {
    var tmpList = rewardList || table()
    var ret = table()
    for (let k in tmpList) {
        var v = tmpList[k]
        table.insert(ret, table([1, "itemId", k], [1, "num", v]))
    }
    table.sort(ret, function (a, b) {
        return a.itemId < b.itemId
    })
    var index = table()
    for (let i = 1, v = ret[1]; v; i++, v = ret[i]) {
        index[v.itemId] = i
    }
    return [ret, index]
}
/**
 * 创建奖励道具
 */
// WinPanel.prototype.buildRewardProps = function () {
//     var self = this
//     var bg2 = self.getChildByName("prop_shadow")
//     var {x, y} = bg2.getPosition()
//     var size = bg2.getContentSize()
//     ;[size.width, size.height] = [size.width * bg2.getScaleX() * 0.8, size.height * bg2.getScaleY()]
//     size.width -= 30
//     for (let i in self.totalRewards) {
//         var v = self.totalRewards[i]
//         if (!v) {
//             continue
//         }
//         var reward = cc.CSLoader.createNode("cocos/panel_success_reward.csb");
//         reward.rewardAnim = cc.CSLoader.createTimeline("cocos/panel_success_reward.csb");

//         reward.setAnchorPoint(cc.p(0.5, 0.5))
//         reward.setCascadeOpacityEnabled(true)
//         prop = reward.getChildByName("icon");
//         prop.setSpriteFrame(UIItemBuilder.createPropIcon(v.itemId).getSpriteFrame());

//         // 微信分享奖励翻倍，奖励图标需要增加动画配置
//         reward.rewardItem = {}
//         reward.rewardItem.itemId = tonumber(v.itemId)
//         reward.rewardItem.num = tonumber(v.num)
//         var sSize = prop.getContentSize()
//         prop.setScale(size.height / sSize.height * 2 / 5)
//         var label = reward.getChildByName("numb_old").getChildByName("label");
//         var newLabel = reward.getChildByName("numb_new").getChildByName("label");
//         label.setString(reward.rewardItem.num);
//         newLabel.setString(reward.rewardItem.num * 2);
//         reward.setVisible(false)
//         reward.setPosition(cc.p((i - 0.5) * size.width * 0.8 / $len(self.totalRewards) - size.width * 0.8 / 2 + 10 + size.width * 0.1, 0))
//         self.rewardNode.addChild(reward, 30)
//         table.insert(self.rewards, table(
//             [1, "prop", prop],
//             [1, "label", label],
//             [1, "newLabel", newLabel],
//             [1, "layer", reward]
//         ))
//     }
// }
/**
 * 播放星星动画
 */
// WinPanel.prototype.playStarAnims = function (callback) {
//     var self = this
//     var scale = self.getScale()
//     var vSize = cc.Director.getInstance().getVisibleSize()
//     var position = cc.p(self.getPosition())
//     var deltaPos = cc.pMul(cc.pSub(position, cc.p(cc.p(vSize.width / 2, vSize.height / 2 - 20))), 0.02)
//     for (let i = 1, v = self.stars[1]; v; i++, v = self.stars[i]) {
//         var sScale = v.getScale()
//         v.setScale(sScale * 2)
//         v.setOpacity(0)
//         v.runAction(cc.Sequence.create(cc.DelayTime.create((i - 1) * 0.25), cc.Spawn.create(cc.FadeIn.create(0.16), cc.ScaleTo.create(0.16, sScale)), cc.CallFunc.create(function () {
//             self.stars_empty[i].setVisible(false)
//             self.setScale(scale * 0.98)
//             // deltaPos.y = deltaPos.y + 145
//             self.setPosition(cc.pSub(position, deltaPos))
//             self.runAction(cc.Spawn.create(cc.ScaleTo.create(0.1, scale), cc.MoveTo.create(0.1, position)))
//             var glow = cc.CSLoader.createNode(self.stars_glow[i])
//             var glowAction = cc.CSLoader.createTimeline(self.stars_glow[i])
//             glow.runAction(glowAction)
//             if (i < 3) {
//                 glow.setScale(v.getScale() + 0.2)
//             } else {
//                 glow.setScale(v.getScale())
//             }
//             glow.setRotation(v.getRotation())
//             glow.setPosition(cc.p(v.getPosition()))
//             self.starPanel.addChild(glow, 20 + (i - 1) * 2)
//             if (i >= 3 && self.oldStar < self.star) {
//                 glowAction.setLastFrameCallFunc(function () {
//                     glowAction.clearLastFrameCallFunc()
//                     glowAction.setLastFrameCallFunc(function () {
//                         glowAction.clearLastFrameCallFunc()
//                         if (i === $len(self.stars)) {
//                             if (callback) {
//                                 callback()
//                             }
//                         }
//                         glow.removeFromParent(true)
//                     })
//                     glowAction.play("part2", false)
//                 })
//                 glowAction.play("part1", false)
//                 v.anim.gotoFrameAndPlay(0, true)
//                 glow.runAction(cc.Sequence.create(cc.DelayTime.create(14 / 30), cc.CallFunc.create(function () {
//                     self.showBanner()
//                     self.fly()
//                 })))
//             } else {
//                 glowAction.setLastFrameCallFunc(function () {
//                     glowAction.clearLastFrameCallFunc()
//                     if (i === $len(self.stars)) {
//                         if (callback) {
//                             callback()
//                         }
//                     }
//                     glow.removeFromParent(true)
//                 })
//                 if (i == $len(self.stars)){
//                     // 打已经过得关卡的时候动画时间太长
//                     glowAction.gotoFrameAndPlay(0, 20, false)
//                 }else{
//                     glowAction.gotoFrameAndPlay(0, false)
//                 }
//                 v.anim.gotoFrameAndPlay(0, true)
//             }
//         })))
//     }
// }
/**
 * 播放奖励跳出动画
 */
// WinPanel.prototype.playAddPropAnim = function (callback) {
//     var self = this
//     if ($len(self.totalRewards) <= 0) {
//         if (callback) {
//             callback()
//         }
//         return 
//     }
//     for (let i = 1, v = self.totalRewards[1]; v; i++, v = self.totalRewards[i]) {
//         let anim = cc.CSLoader.createNode("cocos/panel_success_reward.csb");
//         anim.setCascadeOpacityEnabled(true)
//         let idx = self.rewardIndex[v.itemId]
//         let sprite = anim.getChildByName("icon");
//         sprite.setSpriteFrame(UIItemBuilder.createPropIcon(v.itemId).getSpriteFrame());
//         let label = anim.getChildByName("numb_old").getChildByName("label");
//         label.setString(v.num);
//         anim.setLocalZOrder(25)
//         let position = cc.p(self.rewards[idx].layer.getPosition())
//         anim.setPosition(cc.p(position.x + 50, position.y + 60))
//         self.rewardNode.addChild(anim)
//         anim.setOpacity(0)
//         anim.runAction(cc.Sequence.create(cc.DelayTime.create(0.1 * (i - 1)), cc.Spawn.create(cc.FadeIn.create(0.43), cc.EaseSineOut.create(cc.MoveBy.create(0.43, cc.p(-50, 0))), cc.EaseBackIn.create(cc.MoveBy.create(0.43, cc.p(0, -70)))), cc.MoveBy.create(0.16, cc.p(0, 10)), cc.CallFunc.create(function () {
//             anim.removeFromParent(true)
//             self.rewards[idx].layer.setVisible(true)
//             if (i === $len(self.totalRewards)) {
//                 if (callback) {
//                     callback()
//                 }
//             }
//         })))
//     }
// }
/**
 * 点击空位置
 */
WinPanel.prototype.onClickEmpty = function () {
    var self = this
    //self.dispatchCloseEvent()
}

WinPanel.prototype.onEnterAnimFinish = function () {

    let self = this
    if (!SnsProxy.getInstance().allowShare()){
        self.dispatchEvent({
            name: WinPanelEvent.SkipChallenge
        })
        return
    }else{
        //  优先展示攻略炫耀面板，该面板关闭后再展示求超越
        if (LevelType.isMysteryIslandLevel(self.levelId)){
            self.dispatchEvent({
                name: WinPanelEvent.SkipChallenge
            })
        } 
        // else if(self.medalRankData) {
        //     //弹出勋章排名上升动画，则不在弹出炫耀界面，抖音录屏移到勋章动画界面
        //     self.dispatchEvent({
        //         name: WinPanelEvent.SkipChallenge
        //     })
        // } 
        else {
            self.showStrategyFlauntPanel()
        }
    }
 }

WinPanel.prototype.onEnterAnimStart = function (callback) {
    var self = this
    
    // self.playStarAnims()
    let starNode = self.getStarNode()
    
    for (let i = 1 ; i <= 4; i++){
        if (starNode.getChildByName("star" + i)){
            if (i <= 2){
                starNode.getChildByName("star" + i).actionTimeLine = cc.CSLoader.createTimeline("cocos/panel_success_star_yellow.csb");

            }else if (i == 3){
                starNode.getChildByName("star" + i).actionTimeLine = cc.CSLoader.createTimeline("cocos/panel_success_star_orange.csb");

            }else{
                starNode.getChildByName("star" + i).actionTimeLine = cc.CSLoader.createTimeline("cocos/panel_success_star_blue.csb");

            }
            starNode.getChildByName("star" + i).runAction(starNode.getChildByName("star" + i).actionTimeLine)
    
        }

    }

    function playStarAnim(index){

        // starNode.actionTimeLine.setLastFrameCallFunc(function(){
            
        //     starNode.actionTimeLine.clearLastFrameCallFunc()
        //     if (index > 4) {
            
        //         starNode.actionTimeLine.play("idle", true)
        //         return
        //     }
        //     starNode.actionTimeLine.play( index + "_in", false)

            if (index <= self.star ){
                starNode.getChildByName("star" + index).actionTimeLine.play("in", false)
                starNode.getChildByName("star" + index).actionTimeLine.setLastFrameCallFunc(function(){
                    starNode.getChildByName("star" + index).actionTimeLine.clearLastFrameCallFunc()
                    starNode.getChildByName("star" + index).actionTimeLine.play("idle", true)
                })

            }
            // playStarAnim(index + 1)
        // })
    }
    

    self.actionTimeLine =  cc.CSLoader.createTimeline("cocos/panel_success_panel_success.csb")
    self.runAction(self.actionTimeLine);
    //不显示只为了使用tag
    // let node2 =  QuickCreateAnimNode("cocos/panel_success_panel_success.csb")
    self.actionTimeLine.gotoFrameAndPlay(0, 10, false)
    self.actionTimeLine.setLastFrameCallFunc(function(){
        self.actionTimeLine.clearLastFrameCallFunc()
        //1_in
        playStarAnim(1)
        self.playSuccessWordAnim()
        
        self.actionTimeLine.gotoFrameAndPlay(10, 12, false)
        self.actionTimeLine.setLastFrameCallFunc(function(){
            self.actionTimeLine.clearLastFrameCallFunc()
            

            self.actionTimeLine.play("score_in", false)
            self.scorePanel.runAction(cc.FadeIn.create(0.3)) 
            self.actionTimeLine.setLastFrameCallFunc(function(){
                self.actionTimeLine.clearLastFrameCallFunc()

                self.actionTimeLine.play("prop_in", false)
                playStarAnim(2)
                self.levelPartNode && self.levelPartNode.runAction(cc.FadeIn.create(0.3)) 
                self.activityPartNode && self.activityPartNode.runAction(cc.FadeIn.create(0.3)) 
                self.actionTimeLine.setLastFrameCallFunc(function(){
                    self.actionTimeLine.clearLastFrameCallFunc()

                    self.actionTimeLine.play("btn_orange_in", false)
                    self.addChild(self.doubleTxt)
                    self.buttonAni.actionTimeLine.gotoFrameAndPlay(0, false)
                    self.actionTimeLine.setLastFrameCallFunc(function(){
                        self.actionTimeLine.clearLastFrameCallFunc()

                        self.actionTimeLine.gotoFrameAndPlay(16, 19, false)
                        playStarAnim(3)
                        self.nextButtonAni.actionTimeLine.gotoFrameAndPlay(0, false)
                        self.actionTimeLine.setLastFrameCallFunc(function(){
                            self.actionTimeLine.clearLastFrameCallFunc()

                            self.actionTimeLine.gotoFrameAndPlay(19, 20, false)
                            playStarAnim(4)
                            self.actionTimeLine.setLastFrameCallFunc(function(){
                                // if (UserLevel.getInstance().isHaveEquityMonthTicket()){
                                //     self.addScoreBubble.setVisible(true)
                                //     self.addScoreBubble.runAction(cc.Sequence.create(cc.ScaleTo.create(0.1, 1.2), cc.ScaleTo.create(0.05, 1)))
                                // }
                                self.actionTimeLine.clearLastFrameCallFunc()

                                self.actionTimeLine.play("qipao_change", false)
                                table.each(self.activityPartRewardsNode, function(v, k){
                                    v.qipao.actionTimeLine.gotoFrameAndPlay(10,35,false)
                                    v.qipao.actionTimeLine.setLastFrameCallFunc(function(){
                                        v.qipao.actionTimeLine.clearLastFrameCallFunc()
                                        addNumAni(v, v.timesNum)
                                        v.qipao.actionTimeLine.gotoFrameAndPlay(35,false)
                                    })
                                })
                                self.actionTimeLine.setLastFrameCallFunc(function(){
                                    self.callback && self.callback()
                                    self.actionTimeLine.clearLastFrameCallFunc()
                                    self.actionTimeLine.play("idle", true)
                                })  
                            })  
                        })
                    })  
                })  
            })  
        })
    })

}
/**
 * 弹出面板
 */
WinPanel.prototype.popupAnim = function (callback) {
    var self = this

    BasePanel.prototype.popup.call(self)
    // callback && callback()
    self.callback = callback
    //  显示Banner广告
    var res = self.tryShowBannerAd();
    if (res == 2){
        // 格子广告
        self.bannerAdOffsetY = 140;
        self.bannerAdPanelOffsetY = 100;
    }

    self.dispatchEvent(table([1, "name", WinPanelEvent.StartAnim]))
    // var targetScale = self.getScale()
    // PopoutManager.getInstance().addWithBgFadeIn(self, true, false)
    // var vSize = cc.Director.getInstance().getVisibleSize()
    // var sSize = self.getChildByName("panel_sandbeach_01").getContentSize()
    // //  因为Banner广告的问题，需要向上移动
    // var targetPos = cc.p(cc.p(vSize.width / 2 - sSize.width / 2, vSize.height / 2 - 20 + sSize.width / 2 + self.bannerAdPanelOffsetY))
    // self.setPosition(cc.p(vSize.width / 2, vSize.height / 2 - 20))
    // var startPoint = cc.pMul(cc.pSub(targetPos, cc.p(self.getPosition())), 0.23)
    // self.setPosition(self.getPositionX() + startPoint.x, self.getPositionY() + startPoint.y)
    // self.setScale(0.23)
    // if (SeasideStarManager.getInstance().isOpen()){
    //     targetPos.y = targetPos.y + 100 //海滨之星活动 界面上调
    // }
    // var time = 0.3
    // self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(time, targetScale), cc.MoveTo.create(time, targetPos))), cc.CallFunc.create(function () {
    //     // ButtonPushBounceIdleBubbleAnim.create(self.button)
    //     ButtonPushBounceIdleBubbleAnim.create(self.showoff)
    //     if (callback) {
    //         callback()
    //     }
    //     //  播放排行榜入场动画
    //     if (rank) {
    //         rank.setVisible(true)
    //         rank.runAction(cc.MoveTo.create(14 / 30, cc.p(rank.getPositionX(), rank.getPositionY() + 350)), cc.CallFunc.create(function () {
    //             //rank.setParent(self)
    //         }))
    //     }
    //     if (!SnsProxy.getInstance().allowShare()){
    //         self.dispatchEvent({
    //             name: WinPanelEvent.SkipChallenge
    //         })
    //         return
    //     }else{
    //         //  优先展示攻略炫耀面板，该面板关闭后再展示求超越
    //         if (LevelType.isMysteryIslandLevel(self.levelId)){
    //             self.dispatchEvent({
    //                 name: WinPanelEvent.SkipChallenge
    //             })
    //         }else{
    //             self.showStrategyFlauntPanel()
    //         }
    //     }
    // })))
    // if (self.title) {
    //     var titleGlow = null
    //     if (self.isHardLevel) {
    //         titleGlow = self.title
    //     } else {
    //         let path = "adapter/" + he.MetaInfo.getLanguage() + "/level_panel_win_letter.png"
    //         titleGlow = cc.Sprite.create(path)
    //         titleGlow.removeFromParent(true)
    //         titleGlow.setAnchorPoint(cc.p(self.title.getAnchorPoint()))
    //         titleGlow.setPosition(cc.p(self.title.getPosition()))
    //         self.title.removeFromParent()
    //         self.addChild(titleGlow)
    //     }
    //     titleGlow.setScale(0.5)
    //     titleGlow.setPositionY(titleGlow.getPositionY() - 400)
    //     titleGlow.runAction(cc.Spawn.create(cc.ScaleTo.create(0.3, 1), cc.Sequence.create(cc.EaseSineOut.create(cc.MoveBy.create(0.5, cc.p(0, 500))), cc.EaseSineInOut.create(cc.MoveBy.create(0.15, cc.p(0, -150))), cc.EaseSineIn.create(cc.MoveBy.create(0.15, cc.p(0, 50))))))
    // }
    self.changeBackgroundMusic()
    
        
    return self
}
WinPanel.prototype.changeBackgroundMusic = function () {
    var self = this
    // body
    //MusicPlayer:getInstance():stopBgMusic()
    /* 	MusicPlayer:getInstance():playOtherBgMusic(GameMusicType.kWinLevel, false)
	self:runAction(cc.Sequence:create(
		cc.DelayTime:create(6),
		cc.CallFunc:create(function( ... )
			-- body
			 MusicPlayer:getInstance():playGameSceneBgMusic()
		end)
		))
	 */
}
WinPanel.prototype.onKeyBackClicked = function () {
    var self = this
    self.dispatchCloseEvent()
}

WinPanel.prototype.onCleanup = function () {
    let self = this
    self.isClosed = true
    if (window.mini && mini.supportOpenContext()) {
        self.getScheduler().unscheduleScriptEntry(self.refreshTimer) 
        OpenContextUtil.postMessage({
            command: "exit"
        })
    }
    if (self._kMedalRankOpen) {
        GlobalEventDispatcher.getInstance().removeEventListener(
            kGlobalEvents.kMedalRankOpen,
            self._kMedalRankOpen
        );
        self._kMedalRankOpen = null;
    }
    let frame_res = DressManager.getInstance().getNeedFrameRes()
    for (let i = 0; i < frame_res.length; i++) {
        PassLevelNeedRes.push(frame_res[i]);
    }
    if (GoldElysiumManager.getInstance().isNeedWinPanelProgress()){
        PassLevelNeedRes.push("packed/GoldElysiumProgress.pack")
    }
    if (TTUtil.isOpenSmallPay()){
        PassLevelNeedRes.push("packed/ttGameRevivePanel.pack")
    }

    ResManager.release(PassLevelNeedRes);
    let { getLevelGuideResList, getLevelUsedGuideResList } = require('../config/level/GuideResConfig.js')
    ResManager.release(getLevelUsedGuideResList());
}

WinPanel.prototype.dispatchCloseEvent = function () {
    var self = this
    // 胜利过关回首页要显示插屏广告
    let snsProxy = require("clover/sns/SnsProxy").getInstance();
    snsProxy.setNeedShowInterstitialAdName("inter_levelsucceed", true);

    self.dispatchEvent(table([1, "name", WinPanelEvent.Close]))
}
WinPanel.prototype.dispatchNextEvent = function (isClose) {
    var self = this
    UserManager.getInstance().skipLevelPopout = !!isClose;

    if (self.friendRank_panel) {
        let rank = self.friendRank_panel
        //  播放排行榜出场动画
        rank.runAction(cc.Sequence.create(cc.MoveBy.create(6 / 30, cc.p(0, - 350)), cc.CallFunc.create(function () {
            rank.removeFromParent(true)
            self.dispatchEvent(table([1, "name", WinPanelEvent.NextLevel]))
            let snsProxy = require("clover/sns/SnsProxy").getInstance();
            snsProxy.setNeedShowInterstitialAdName("inter_levelsucceed", true);
        })))
    } else {
        self.dispatchEvent(table([1, "name", WinPanelEvent.NextLevel]))
        let snsProxy = require("clover/sns/SnsProxy").getInstance();
        snsProxy.setNeedShowInterstitialAdName("inter_levelsucceed", true);
    }
}
WinPanel.prototype.starCheck = function () {
    var self = this
    if (self.oldStar && tonumber(self.oldStar) && (tonumber(self.oldStar) < 4 && self.star === 4 || tonumber(self.oldStar) < 3 && self.star === 3)) {
        var levelID = tonumber(self.levelId)
        var bool = false
        if (LevelType.isMainLevel(levelID)) {
            bool = true
        }
        return true && bool
    }
    return false
}
/**
 * 展示挑战引导
 */
WinPanel.prototype.showChallengeGuide = function() {
    let self = this
    // 抖音结算界面 暂时去掉挑战引导 
    if (window.mini && mini.getPlatform() == MiniPlatform.tt){
        return
    }
    // if (!SnsProxy.getInstance().allowShare()){
    //     self.dispatchEvent({
    //         name: WinPanelEvent.SkipChallenge
    //     })
    //     return
    // }

    
    if(true) {
        self.dispatchEvent({
            name: WinPanelEvent.SkipChallenge
        })
        return
    }

    //-------------------------测试伪逻辑-------------------------
    // if (__DEBUG){
        // let PassLevelWinChallengeGuide = require("activity/PassLevel/PassLevelWinChallengeGuide")
        // self.challengePanel = PassLevelWinChallengeGuide.create().start(self, getText("passlevel.showoff.bubble", table([1, "rank", 500])), function () {
        //     self.clickShowoff()
        // }, true)
        // return


    //     self.checkFakeRankOver();
    //     return
    // }
    //----------------------------------------------------------------
    var onSuccess = function(evt){
        CfgManager.load("game")
        .then((data) => {
            let config = data.get("game");
            var lastShowOffTime = UserManager.getInstance().getLastShowOffTime();
            if (lastShowOffTime == "0"){
                lastShowOffTime = Localhost.timeInSec();
            }else{
                lastShowOffTime = Math.floor(UserManager.getInstance().getLastShowOffTime()/1000);
            }
            var lastShowOffDTime = Localhost.timeInSec() - lastShowOffTime;
            var needTime = parseInt(config.passlevel_showoff_time)/1000;
            cc.log("-----------lastShowOffDTime", lastShowOffDTime, "needTime", needTime);
            if (lastShowOffDTime > needTime){
                self.checkFakeChallenge(evt.data, config);
            }else{
                self.checkRealChallenge();
            }
            CfgManager.release("game");
        });
    }
    var onFail = function(evt){
        cc.error(evt.data);
        self.dispatchEvent({
            name: WinPanelEvent.SkipChallenge
        })
    }
    var uid = UserManager.getInstance().uid;
    var http = GetPassLevelShowOffConfigHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onFail)
    http.load(uid)
}

// 检查真求超越条件
WinPanel.prototype.checkRealChallenge = function(){
    var self = this;
    let PassLevelWinChallengeGuide = require("activity/PassLevel/PassLevelWinChallengeGuide")
    //大于指定关卡，首次三星通关，而且没有出现过引导
    if(!UserLocalSettings.getSetting("challengeGuide_first3star", false)) {
        if(self.levelId >= 6) {
            self.showoffType = 0;
            self.challengePanel = PassLevelWinChallengeGuide.create().start(self, getText("win.panel.changllenge.guide1", table([1, "score", self.score])), function () {
                cc.log("guide finish")
                self.clickShowoff()
            }, false, self.bannerAdOffsetY + self.bannerAdPanelOffsetY)
            DCAssist.userTrack("challenge", "popup_guide01", {"levelId":self.levelId})
            DCAssist.userTrack("share", "level_showoff_share_show", {"type":0, "rank":self.challengeRank});
            UserLocalSettings.setSetting("challengeGuide_first3star", true)
            UserLocalSettings.setSetting("challengeGuide_apear", 1)
        }else{
            self.dispatchEvent({
                name: WinPanelEvent.SkipChallengeCheckRankOver
            })
        }
        return
    }else{
        let overData = UserLocalSettings.getSetting("challengeGuide_firstOverOtherLevels", false)
        // let limit = UserManager.getInstance().getSystemConfig("challengeRankOpenLevel") || 11
        let limit = self.passlevelShowoffLevel;
        if(self.levelId < limit){
            self.dispatchEvent({
                name: WinPanelEvent.SkipChallengeCheckRankOver
            })
            return
        }
        if(overData && overData["lv"+self.levelId]) {
            self.dispatchEvent({
                name: WinPanelEvent.SkipChallengeCheckRankOver
            })
            return
        }
        //每天同一个人出现这个引导次数限制
        let lastTimeObj = UserLocalSettings.getSetting("challengeGuide_firstOverOtherTime", {time:0, num:0})
        if(lastTimeObj) {
            let curT = (new Date()).getTime()
            if(isSameYMD(lastTimeObj.time, curT)) {
                cc.log("关末分享引导次数", lastTimeObj.num, self.passlevelShowoffNum)
                if(lastTimeObj.num>=self.passlevelShowoffGuideTimes) {
                    self.dispatchEvent({
                        name: WinPanelEvent.SkipChallenge
                    })
                    return
                }else{
                    lastTimeObj.time = curT
                    lastTimeObj.num++
                }
            }else{
                lastTimeObj.time = curT
                lastTimeObj.num = 1
            }
        }

        //所有关卡中只要有一关的分数第一次超过指定百分比的时候（需要后端传值）
        let rank = self.challengeRank
        let score = self.score
        if(rank && rank>0){
            self.showoffType = 0;
            self.challengePanel = PassLevelWinChallengeGuide.create().start(self, getText("win.panel.changllenge.guide2", table([1, "rank", rank],[1, "score", score])), function () {
                cc.log("close PassLevelWinChallengeGuide")
                self.clickShowoff()
            }, false, self.bannerAdOffsetY + self.bannerAdPanelOffsetY)
            DCAssist.userTrack("challenge", "popup_guide02", {"levelId":self.levelId})
            DCAssist.userTrack("share", "level_showoff_share_show", {"type":0, "rank":rank});
            let obj = UserLocalSettings.getSetting("challengeGuide_firstOverOtherLevels", false)
            if(obj) {
                obj["lv"+self.levelId] = true
            }else{
                obj = {}
                obj["lv"+self.levelId] = true
            }
            
            UserLocalSettings.setSetting("challengeGuide_firstOverOtherLevels", obj)
            UserLocalSettings.setSetting("challengeGuide_apear", 2)
            UserLocalSettings.setSetting("challengeGuide_firstOverOtherTime", lastTimeObj)
        } else {
            self.dispatchEvent({
                name: WinPanelEvent.SkipChallengeCheckRankOver
            })
        }
    }
}

// 检查伪求超越条件
WinPanel.prototype.checkFakeChallenge = function(){
    var self = this;
    
    var onSuccess = function(evt){
        if (evt.data.overLimit){
            self.dispatchEvent({
                name: WinPanelEvent.SkipChallenge
            })
            return;
        }
        if (evt.data.flag && !evt.data.next){
            // 伪全国排名
            //每天同一个人出现这个引导次数限制
            let lastTimeObj = UserLocalSettings.getSetting("challengeGuide_firstOverOtherTime", {time:0, num:0})
            if(lastTimeObj) {
                let curT = (new Date()).getTime()
                if(isSameYMD(lastTimeObj.time, curT)) {
                    cc.log("关末分享引导次数", lastTimeObj.num, self.passlevelShowoffNum)
                    if(lastTimeObj.num>=self.passlevelShowoffGuideTimes) {
                        self.dispatchEvent({
                            name: WinPanelEvent.SkipChallenge
                        })
                        return
                    }else{
                        lastTimeObj.time = curT
                        lastTimeObj.num++
                    }
                }else{
                    lastTimeObj.time = curT
                    lastTimeObj.num = 1
                }
            }

            function showPasslvl(authorize){
                if (authorize){
                    refreshAuthorize()
                }

                self.showoffType = 1;
                let PassLevelWinChallengeGuide = require("activity/PassLevel/PassLevelWinChallengeGuide")
                self.challengePanel = PassLevelWinChallengeGuide.create().start(self, getText("passlevel.showoff.bubble", table([1, "rank", evt.data.rank])), function () {
                    self.clickShowoff()
                }, true, self.bannerAdOffsetY + self.bannerAdPanelOffsetY);
                DCAssist.userTrack("share", "level_showoff_share_show", {"type":1, "rank":evt.data.rank});
                
                UserLocalSettings.setSetting("challengeGuide_apear", 2)
                UserLocalSettings.setSetting("challengeGuide_firstOverOtherTime", lastTimeObj)
            }
            AuthorizeMgr.checkAuthorize(showPasslvl, showPasslvl, getText("wechat.info.ask.showoff.txt"), "showoff")
        }else{
            self.checkFakeRankOver();
        }
    }

    var onFail = function(evt){
        if (evt.data == 760606){
            cc.log("今日分享次数已达上限");
        }else{
            cc.error(evt.data);
        }
        self.dispatchEvent({
            name: WinPanelEvent.SkipChallenge
        })
    }

    var uid = UserManager.getInstance().uid;
    var http = GetPassLevelShowOffInfo.new(true);
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onFail)
    http.load(uid, self.levelId, self.star);
}

// 检查分数超越
WinPanel.prototype.checkFakeRankOver = function(){
    var self = this;
    var onRankSuccess = function(rankList){
        self.checkFakeChallengeGetRankSuccess(rankList);
    }
    var onRankFail = function(){
        self.dispatchEvent({
            name: WinPanelEvent.SkipChallenge
        })
    }
    if (self.levelId < self.passlevelRankOverLevel) {
        onRankFail()
    }else {
        UserRank.getInstance().getFriendRank(self.levelId, onRankSuccess, onRankFail);
    }
    
}
WinPanel.prototype.checkFakeChallengeGetRankSuccess = function(rankList){
    cc.log("friend rank list:", rankList);
    var self = this;
    var scoreData = UserScore.getInstance().getLastScoreBeforeUpdate();
    var oldScore = scoreData.score;
    var oldLevel = scoreData.level;
    cc.log("oldScore", oldScore, "oldLevel", scoreData.level);
    var oldRank = 1;
    var newRank = 1;
    var uid = UserManager.getInstance().uid;

    //每天同一个人出现分享次数限制
    let lastTimeObj = UserLocalSettings.getSetting("challengeGuide_firstOverOtherTime", {time:0, num:0})
    if(lastTimeObj) {
        let curT = (new Date()).getTime()
        if(isSameYMD(lastTimeObj.time, curT)) {
            cc.log("关末分享引导次数", lastTimeObj.num, self.passlevelShowoffNum)
            if(lastTimeObj.num>=self.passlevelShowoffNum) {
                self.dispatchEvent({
                    name: WinPanelEvent.SkipChallenge
                })
                return
            }else{
                lastTimeObj.time = curT
                lastTimeObj.num++
            }
        }else{
            lastTimeObj.time = curT
            lastTimeObj.num = 1
        }
    }

    var failCb = function (error) {
        if (error){
            cc.error(error);
        }
        self.dispatchEvent({
            name: WinPanelEvent.SkipChallenge
        })
    }

    for(var i = 1; i <= rankList.length-1; i++){
        if (rankList[i].profile.uid != uid && rankList[i].score.score > oldScore){
            oldRank++;
        }
    }
    for(var i = 1; i <= rankList.length-1; i++){
        if (rankList[i].profile.uid != uid && rankList[i].score.score > self.score){
            newRank++;
        }
    }
    cc.log("oldRank", oldRank, "newRank", newRank);
    if (newRank < oldRank || (newRank == 1 && oldScore == 0)){
        // 分数超越好友
        self.showoffType = 2;

        var shareType = 0;
        self.showoffRankoverData = null;

        // if (newRank == 1){
        //     if (self.checkRankFirst()){
        //         shareType = 2;
        //     }
        // }else{
            shareType = 1;
        // }
        if (shareType){
            var PassLevelShare = require("activity/PassLevel/PassLevelWinScoreOverFrinedShare");
            PassLevelShare.show(shareType, self.showoffRankoverData, failCb, { levelId: scoreData.curLevel, score: self.score});
                
            // UserLocalSettings.setSetting("challengeGuide_apear", 2)
            // UserLocalSettings.setSetting("challengeGuide_firstOverOtherTime", lastTimeObj)

            return;
        }
    }
    
    oldRank = 1;
    newRank = 1;
    cc.log("oldLevel", oldLevel, "self.levelId", self.levelId);
    var friendManager = FriendManager.getInstance();
    var friends = friendManager.getFriends()
    //cc.log(friends[0]);
    for (var friendUid in friends[0]){
        if (friendUid != uid && friendManager.isFriend(friendUid)){
            var friendUser = friends[0][friendUid];
            cc.log("friendUser", friendUser);
            var topLevelId = friendUser.topLevelId - 1;
            if (topLevelId >= oldLevel){
                oldRank++;
            }
            if (topLevelId >= self.levelId){
                newRank++;
            }
        }
    }
    cc.log("oldRank", oldRank, "newRank", newRank);
    if (newRank < oldRank){
        // 关卡超越好友
        self.showoffType = 3;
        var PassLevelShare = require("activity/PassLevel/PassLevelWinScoreOverFrinedShare");
        PassLevelShare.show(3, null, failCb, { levelId: scoreData.curLevel});
            
        // UserLocalSettings.setSetting("challengeGuide_apear", 2)
        // UserLocalSettings.setSetting("challengeGuide_firstOverOtherTime", lastTimeObj)

        return;
    }

    self.dispatchEvent({
        name: WinPanelEvent.SkipChallenge
    })
}

//检查第一的出现次数
WinPanel.prototype.checkRankFirst = function(){
    var self = this;
    
    var rule = self.passLevelShowoffFirstplace.split(",");
    cc.log("rule", rule);
    for(var i = 0; i < rule.length; i++){
        rule[i] = rule[i].split(":");
    }
    var flag = false;
    var temp = Persistence.readFileData(LocalDataFiles.kPassLevelShowoffFirst);
    var showoffData = [];
    if (temp == null || temp.length == 1){
        for(var i = 0; i < rule.length; i++){
            var d = [rule[i][0], 0];
            showoffData.push(d);
        }
    }else{
        for(var i = 1; i < temp.length; i++){
            var d = [temp[i][1], temp[i][2], temp[i][3]];
            showoffData.push(d);
        }
    }
    // var showoffData = cc.UserDefault.getInstance().getStringForKey(LOCAL_PASS_LEVEL_SHOWOFF_FIRST, "");
    // if (showoffData == ""){
    //     showoffData = [];
    //     for(var i = 0; i < rule.length; i++){
    //         var d = [rule[i][0], 0];
    //         showoffData.push(d);
    //     }
    // }else{
    //     showoffData = JSON.parse(showoffData);
    // }
    var levelMin = 1;
    for(var i = 0; i < rule.length; i++){
        var timesMax = parseInt(rule[i][1]); //规则里的限制次数
        var levelMax = parseInt(rule[i][0]);
        cc.log("levelMin", levelMin, "levelMax", levelMax, "timesMax", timesMax);
        if (self.levelId >= levelMin && self.levelId <= levelMax){
            // 规则里-1是无限制次数
            if (timesMax == -1){
                flag = true;
            }else{
                var hasData = false;
                var curTimes = 0;
                var idx = 0;
                for (var j = 0; j < showoffData.length; j++){
                    if (showoffData[j][0] == levelMin && showoffData[j][1] == levelMax){
                        hasData = true;
                        idx = j;
                        break;
                    }
                }
                if (!hasData){
                    var d = [levelMin, levelMax, 0];
                    showoffData.push(d);
                    curTimes = 0;
                    idx = showoffData.length-1;
                }
                curTimes = showoffData[idx][2];
                cc.log("idx", idx)
                if (curTimes >= timesMax){
                    flag = false;
                }else{
                    var hasTimes = timesMax - curTimes;
                    var rate = hasTimes/(levelMax+1-self.levelId);
                    var r = Math.random();
                    cc.log("rate", rate, r);
                    if (r < rate){
                        flag = true;
                        showoffData[idx][2] = curTimes+1;
                    }
                    
                }
            }
            break;
        }else{
            levelMin = levelMax+1;
        }
    }
    cc.log("flag", flag);
    
    self.showoffRankoverData = JSON.stringify(showoffData);
    cc.log("self.showoffRankoverData", self.showoffRankoverData);
    // cc.UserDefault.getInstance().setStringForKey(LOCAL_PASS_LEVEL_SHOWOFF_FIRST, JSON.stringify(showoffData));
    
    return flag
}

var donotPlay = true
WinPanel.prototype.showBanner = function (onCallBack) {
    var self = this
    if (donotPlay) {
        if (type(onCallBack) === "function") {
            onCallBack()
        }
        return 
    }
    if (self.starCheck()) {
        var scene = cc.Director.getInstance().getRunningScene()
        if (scene) {
            self.banner = require("clover/scene/component/homescene/HomeSceneInfoBanner").create(null, true)
            self.banner.showInOtherScene(onCallBack)
            scene.addChild(self.banner, 9999)
        }
    }
}
WinPanel.prototype.hideBanner = function () {
    var self = this
    if (self.banner) {
        self.banner.hideInOtherScene(function () {
            self.banner.removeFromParent(true)
            self.banner = null
        })
    }
}
WinPanel.prototype.onHit = function () {
    var self = this
    if (self.banner) {
        self.banner.onHit()
    }
}
WinPanel.prototype.getGoTop = function () {
    var self = this
    if (self.banner) {
        self.banner.getGoTop(function () {
            self.banner.removeFromParent(true)
            self.banner = null
        })
    }
}
WinPanel.prototype.fly = function () {
    var self = this
    if (donotPlay) {
        return 
    }
    var wSize = cc.Director.getInstance().getWinSize()
    var globalPos = cc.p(wSize.width / 2, wSize.height / 2)
    function call() {
        var scene = cc.Director.getInstance().getRunningScene()
        scene.isNowExist = true
        if (scene && globalPos) {
            var bombStar
            var container
            var pre_pos
            var num_c = 0
            function createStar() {
                if (!scene.isNowExist) {
                    return 
                }
                if (!bombStar || type(bombStar.getChildByName) !== "function" || !bombStar.getChildByName("sdf")) {
                    return 
                }
                var pos = cc.p(bombStar.getChildByName("sdf").getPosition())
                container.setPosition(pos)
                if (pos.y !== pre_pos.y && pos.x !== pre_pos.x) {
                    var ang = math.deg(Math.atan((pos.y - pre_pos.y) / (pos.x - pre_pos.x)))
                    if (pos.x - pre_pos.x > 0) {
                        if (pos.y - pre_pos.y > 0) {
                            ang = -ang
                        } else {
                            ang = -ang
                        }
                    } else if (pos.y - pre_pos.y > 0) {
                        ang = -180 - ang
                    } else {
                        ang = 180 - ang
                    }
                    container.setRotation(ang + 90)
                    num_c = num_c + 1
                    if (num_c % 2 === 0 && num_c >= 35) {
                        for (let i = 1; i <= 1; i += 1) {
                            FrameLoader.loadImageWithPlist("cocos/gameScene.plist")
                            var star = cc.Sprite.createWithSpriteFrameName("gameScene/fly_star_small.png")
                            star.setScale(math.random(6, 8) / 10)
                            star.setRotation(math.random(0, 360))
                            star.setPosition(pre_pos.x + math.random(-10, 10), pre_pos.y + math.random(-10, 10))
                            var actionList = table()
                            table.insert(actionList, cc.FadeOut.create(10 / 30))
                            table.insert(actionList, cc.CallFunc.create(function () {
                                star.removeFromParent(true)
                            }))
                            star.runAction(cc.Sequence.create(actionList))
                            bombStar.addChild(star, 9999)
                        }
                    }
                    pre_pos = pos
                }
            }
            function createFlyStar() {
                cc.log("##########$$$$$$$$$$$$$1341234!!!!!!!!!1")
                if (!scene.isNowExist) {
                    return 
                }
                cc.log("##########$$$$$$$$$$$$$1341234!!!!!!!!!2")
                if (!bombStar || type(bombStar.getChildByName) !== "function" || !bombStar.getChildByName("sdf")) {
                    return 
                }
                cc.log("##########$$$$$$$$$$$$$1341234!!!!!!!!!3")
                container = cc.Node.create()
                container.setCascadeOpacityEnabled(true)
                FrameLoader.loadImageWithPlist("cocos/gameScene.plist")
                var star = bombStar.getChildByName("sdf")
                var starPos = cc.p(star.getPosition())
                var starTargetPos = star.getParent().convertToNodeSpace(cc.p(wSize.width / 2, wSize.height - 60))
                var light = cc.Sprite.createWithSpriteFrameName("gameScene/fly_star_" + self.star + "_light.png")
                light.setAnchorPoint(cc.p(0.5, 0.7))
                light.setScaleX(self.star === 3 && 0.8 || 0.95)
                light.setScaleY(1.2)
                container.setOpacity(0)
                container.addChild(light)
                container.setPosition(starPos)
                container.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.DelayTime.create(1 / 60), cc.CallFunc.create(createStar))))
                bombStar.addChild(container, -9999)
                pre_pos = cc.p(starPos.x, starPos.y)
                var actionList = table()
                table.insert(actionList, cc.DelayTime.create(12 / 30))
                table.insert(actionList, cc.FadeTo.create(6 / 30, 200))
                table.insert(actionList, cc.DelayTime.create(6 / 30))
                table.insert(actionList, cc.FadeOut.create(6 / 30))
                container.runAction(cc.Sequence.create(actionList))
                var actionList = table()
                table.insert(actionList, cc.DelayTime.create(12 / 30))
                table.insert(actionList, cc.ScaleTo.create(10 / 30, self.star === 3 && 0.8 || 0.95, 1.5))
                table.insert(actionList, cc.ScaleTo.create(6 / 30, self.star === 3 && 0.8 || 0.95, 0.5))
                container.runAction(cc.Sequence.create(actionList))
                var actionList = table()
                var bezierConfig = table(
                    [0, cc.p(starPos.x + 150, starPos.y - 300)],
                    [0, cc.p(starTargetPos.x + 280, starTargetPos.y + 200)],
                    [0, starTargetPos]
                )
                table.insert(actionList, cc.EaseSineIn.create(cc.BezierTo.create(30 / 30, bezierConfig)))
                star.runAction(cc.Sequence.create(actionList))
                var actionList = table()
                table.insert(actionList, cc.RotateBy.create(15 / 30, -360))
                table.insert(actionList, cc.RotateBy.create(15 / 30, self.star === 3 && -100 || -85))
                star.runAction(cc.Sequence.create(actionList))
                var actionList = table()
                table.insert(actionList, cc.ScaleTo.create(18 / 30, 0.75))
                table.insert(actionList, cc.ScaleTo.create(9 / 30, 0.62))
                table.insert(actionList, cc.ScaleTo.create(3 / 30, 0.15))
                star.runAction(cc.Sequence.create(actionList))
                var actionList = table()
                table.insert(actionList, cc.DelayTime.create(30 / 30))
                table.insert(actionList, cc.CallFunc.create(function () {
                    self.onHit()
                }))
                table.insert(actionList, cc.EaseSineOut.create(cc.ScaleTo.create(8 / 30, 0.35)))
                table.insert(actionList, cc.EaseSineIn.create(cc.ScaleTo.create(6 / 30, 0.2)))
                table.insert(actionList, cc.ScaleTo.create(4 / 30, 0.3))
                table.insert(actionList, cc.DelayTime.create(0.3))
                table.insert(actionList, cc.CallFunc.create(function () {
                    self.getGoTop()
                }))
                table.insert(actionList, cc.MoveBy.create(0.2, cc.p(0, -20)))
                table.insert(actionList, cc.MoveBy.create(0.13, cc.p(0, 100)))
                table.insert(actionList, cc.CallFunc.create(function () {
                    container.stopAllActions()
                }))
                star.runAction(cc.Sequence.create(actionList))
            }
            function createLight() {
                FrameLoader.loadImageWithPlist("cocos/gameScene.plist")
                bombStar = cc.CSLoader.createNode("cocos/gameScene_star_fly_pre_" + self.star + ".csb")
                var anim = cc.CSLoader.createTimeline("cocos/gameScene_star_fly_pre_" + self.star + ".csb")
                bombStar.runAction(anim)
                anim.gotoFrameAndPlay(0, false)
                anim.setLastFrameCallFunc(function () {
                    anim.clearLastFrameCallFunc()
                })
                if (self.star === 4) {
                    bombStar.setRotation(-12.5)
                }
                bombStar.setScale(1)
                bombStar.setPosition(globalPos.x, globalPos.y)
                scene.addChild(bombStar, 9999)
                globalPos = bombStar.convertToWorldSpace(cc.p(bombStar.getChildByName("sdf").getPosition()))
            }
            createLight()
            setTimeOut(createFlyStar, 18 / 30)
        }
    }
    if (self.starCheck()) {
        var star = self.stars[$len(self.stars)]
        globalPos = star.getParent().convertToWorldSpace(cc.p(star.getPosition()))
        call()
    }
}
WinPanel.prototype.buildRank = function (medalData) {
    var self = this
    const isMystery = LevelType.isMysteryIslandLevel(self.levelId);
    if(isMystery){
        console.log("当前处于神秘岛关卡，不展示排行榜");
        return;
    }
    const friendType =  UserManager.getInstance().getFriendRankType();
    if(friendType || medalData) {
        if(self.isClosed) return;
        //打点
        let pf = "friend_rank";
        if(!friendType || (medalData && medalData.rank > 0)) {
            pf = "global_rank";
        }
        let num = 0;
        let record = 0;
        if(self.medalRankData) {
            num = self.medalRankData.count;
            record = self.medalRankData.rank;
        }

        let params = {
            session: DCAssist.dcForStartGameParams.session,
            current_stage: self.levelId,
            record,
            num,
            pf,
        }
        MedalRankManager.getInstance().dcSimple("stage_end_page_show", params);
        //
        self.friendRank_panel = MedalRankList.create(self.levelId, medalData, params, "stage_end_rank_click");
        self.friendRank_panel.setAnchorPoint(cc.p(0.5, 0));
        //设置排行榜所在的位置
        let posY = -display.height / 2 /self._scale + self.friendRank_panel.height / 2;
        if (cc.sys.os === cc.sys.OS_IOS && display.height / display.width > 1.78) {
            posY += 20;
        }
        self.friendRank_panel.setPosition(cc.p(display.width / 2, posY));
        self.addChild(self.friendRank_panel);
        self.friendRank_panel.setLocalZOrder(9999);
    } 
}
/**
 * 不知道干啥的
 */
WinPanel.prototype.recordData = function () {
    var self = this
    self.fabNames = table(
        "star_shadow",
        "prop_shadow",
        "button",
        "shadow",
        "showoff",
        // "propDeco",
        "newFourStar",
        "scoreTxt",
        "score"
    )
    for (let i = 1; i <= 4; i += 1) {
        table.insert(self.fabNames, "shadow" + i)
        table.insert(self.fabNames, "star_e" + i)
        table.insert(self.fabNames, "star" + i)
        table.insert(self.fabNames, "star_f" + i)
        table.insert(self.fabNames, "empty_f" + i)
    }
    self.fabProps = table()
    for (let k in self.fabNames) {
        var v = self.fabNames[k]
        self.fabProps[v] = table()
        var child = self.getChildByName(v)
        if (child) {
            self.fabProps[v][1] = child.getPositionY()
            self.fabProps[v][2] = child.getOpacity()
        } else {
            self.fabProps[v][1] = 0
            self.fabProps[v][2] = 0
        }
    }
    //self.bg2ContentSize = self.getChildByName("bg2").getContentSize()
    self.targetNode = cc.Node.create()
    self.addChild(self.targetNode)
}

/**
 * 展示攻略炫耀面板
 */
WinPanel.prototype.showStrategyFlauntPanel = function () {
    var self = this

    self.isBusy = false
    function onCloseCallback () {
        //  新需求，攻略炫耀页面显示后不再显示排行榜炫耀界面，后续有新的显示需求你就直接加这吧
        //self.showChallengeGuide()
        self.isBusy = false
    }

    function popStrategyPanel(authorize) {
        if (authorize){
            refreshAuthorize()
        }
        StrategyFlauntPanel.load(onCloseCallback).then(() => {
            let panel = StrategyFlauntPanel.create(self.strategyId, self.levelId, onCloseCallback)
            if (window.mini && mini.getPlatform() == MiniPlatform.tt){
                var shareFunc = function(path, topics, rewards){
                    DCAssist.userTrack("douyin_video_share", "video_share_show", {click_type:"show", current_stage:self.levelId});
                    panel.addTTShareBtn(path, topics, rewards, self.levelId);
                }
                var noShareFunc = function(){
                    
                }
                self.ttCheckRecorderShare(shareFunc, noShareFunc);
            }
        })
    }
    // 攻略炫耀展示前 检查是否授权
    if (self.strategyId && self.strategyId.length > 0) {
        AuthorizeMgr.checkAuthorize(popStrategyPanel, popStrategyPanel, getText("wechat.info.ask.leveltip.txt"), "leveltip")
    } else {
        // 攻略炫耀面板不满足展示条件，显示下一优先级的炫耀面板
        // 抖音需要检查是否是否可以分享录屏
        if (window.mini && mini.getPlatform() == MiniPlatform.tt && UserManager.getInstance().isInReview()){
            var shareFunc = function(path, topics, rewards){
                DCAssist.userTrack("douyin_video_share", "video_share_show", {click_type:"show", current_stage:self.levelId});
                var ttShare = require("activity/PassLevel/PassLevelTTShareVideo");
                ttShare.show(path, topics, rewards, handler(self, self.showChallengeGuide), self.levelId);
            }
            var noShareFunc = function(){
                self.showChallengeGuide();
            }
            self.ttCheckRecorderShare(shareFunc, noShareFunc);
        }else{
            self.showChallengeGuide()
        }
    }
}

WinPanel.prototype.ttCheckRecorderShare = function(shareFunc, noShareFunc){
    var scene = cc.Director.getInstance().getRunningScene();
    if (scene.name != "GameScene" && scene.name != "ReplayGameScene"){
        return;
    }

    var ttShareTopic = null;
    var ttShareRewards = null;
    var ttShareTimesLimit = null;

    var check = function(){
        var curTimes = UserManager.getInstance().getDailyData().douyinShareVideoCnt || 0;
        console.log("抖音分享次数", curTimes, ttShareTimesLimit)
        if (curTimes >= ttShareTimesLimit){
            noShareFunc();
            return;
        }
        curTimes = curTimes + 1;

        var logic = scene.logic;
        console.log(logic.ttRecorder, logic.ttRecorderPath, logic.ttRecorderClipIndexList)

        var rewards = [];
        var rewardsData = ttShareRewards.split(';');
        for (var i = 0; i < rewardsData.length; i++) {
            var shareTimes = parseInt(rewardsData[i].substring(0, rewardsData[i].indexOf(':')));
            if (shareTimes == curTimes){
                var data = rewardsData[i].substring(rewardsData[i].indexOf(':') + 1);
                data = data.substr(1, data.length - 2);
                data = data.split(',');
                for (var j = 0; j < data.length; j++) {
                    var itemData = data[j].split(':');
                    rewards[j] = {};
                    rewards[j].id = itemData[0];
                    rewards[j].num = itemData[1];
                }
            }
        }
        
        if (logic.ttRecorder && logic.ttRecorderPath){
            if (logic.ttRecorderClipIndexList && logic.ttRecorderClipIndexList.length > 0){
                logic.ttRecorder.clipVideo({
                    path: logic.ttRecorderPath,
                    success(res){
                        shareFunc(res.videoPath, ttShareTopic, rewards);
                    },
                    fail(){
                        noShareFunc();
                    }
                });
            }else{
                shareFunc(logic.ttRecorderPath, ttShareTopic, rewards);
            }
        }else{
            noShareFunc();
        }
    }

    CfgManager.load("game").then(()=>{
        var config = CfgManager.get("game");

        ttShareTopic = config.douyin_video_share_topic || ["海滨消消乐","开心消消乐","消消乐","梦幻家园","梦幻花园","宾果消消消"];
        ttShareRewards = config.douyin_video_share_rewards || "1:{14:5,10017:1};2:{10022:1,2:5000};3:{10011:1,2:3000}";
        ttShareTimesLimit = config.douyin_video_share_times_daily_limit || 5;
        console.log(ttShareTopic, ttShareRewards, ttShareTimesLimit)

        check();

        CfgManager.release("game");
    }).catch((err) => {
        console.error("load game config failed!", err);
        noShareFunc();
    });
}

WinPanel.prototype.checkRequestSubscribeSystemMessage = function(callback){
    let self = this
    let needRequestSubscribeSystemMessage = UserManager.getInstance().needRequestSubscribeSystemMessage
    let lastShowSubscribeWhatsNewTs = UserManager.getInstance().userExtend.lastShowSubscribeWhatsNewTs
    self.tipSp = null
    self.notNeedTip = false
    console.log("[subscribe] checkRequestSubscribeSystemMessage", needRequestSubscribeSystemMessage)
    console.log("[subscribe] lastShowSubscribeWhatsNewTs", lastShowSubscribeWhatsNewTs)
    if (needRequestSubscribeSystemMessage == true){
        UserManager.getInstance().needRequestSubscribeSystemMessage = false
        UserManager.getInstance().userExtend.lastShowSubscribeWhatsNewTs = Localhost.time()
        console.log("[subscribe] lastShowSubscribeWhatsNewTs", lastShowSubscribeWhatsNewTs)
        DCAssist.userTrack("subscription","subscription_enter",{type:"stage_end"})
        GameProxy.getInstance().tryRequestSubscribeSystemMessage("SYS_MSG_TYPE_WHATS_NEW", 
        (success)=>{
            console.log("[subscribe] callback success", success)
            DCAssist.userTrack("subscription","subscription_result",{type:"stage_end", open:success?1:0})
            var http = subscribeMessageHttp.new();
            http.load({module:"subscription_whats_new"});
            self.notNeedTip = true
            if (self.tipSp){
                self.tipSp.removeFromParent()
            }
            if (callback){
                callback()
            }
        })
        setTimeout(()=>{
            if (self && self.isClosed) {
                return 
            }
            let tip_path = "https://statich5clover.happyelements.com/resource/upload/clover_wx_update_tips2.png"
            ResManager.load(tip_path, {
                onSuccess: ()=> {
                    console.log("[subscribe] load tip onSuccess, notNeedTip", self.notNeedTip)
                    if (self.notNeedTip){
                        return
                    }
                    self.tipSp = cc.Sprite.create(tip_path)
                    self.addChild(self.tipSp, 9999)
                    self.tipSp.setPosition(0, 180)
                    self.tipSp.setScale(0.8)
                },
                onFailure: ()=> {},
                autoRetry: 0
            })
        }, 1000)
    }
    return needRequestSubscribeSystemMessage && (lastShowSubscribeWhatsNewTs == 0)
}

WinPanel.prototype.dc4ShareBtnShow = function() {
    let self = this;

    if (!self.button || !self.button.isVisible())
        return;

    if (!self.totalRewards || $len(self.totalRewards) <= 0)
        return;

    if (!self.rewardConfig || self.rewardConfig.isGetThisReward)
        return;

    if (self.rewardConfig.times > 0 && !self.rewardConfig.isGetShareRewardMax && !self.rewardConfig.isGetShareReward && self.rewardConfig.isGetEnergyMax && SnsProxy.getInstance().allowShare()) {
        DCAssist.dc4ShareShow("level_bonus");
    }
    return;
}

WinPanel.prototype.fitScreen = function () {
    var self = this
    var scaleY = display.height / GamePlayConfig_Design_Height
    var scaleX = display.width / GamePlayConfig_Design_Width

    var scale = Math.min(scaleX, scaleY)
    cc.log("fitScreen", scale)
    self._scale = scale
    self.setScale(self._scale)
}
module.exports = table([0, WinPanel], [0, WinPanelEvent])
